// src/AdChoices.tsx
import * as React from "react";
function AdChoices({ width = 24, height = 24 }) {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width,
      height
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M.594.695l-.594.7v10.707c0 10.488.008 10.718.477 11.3.73.914 1.933.82 4.039-.324.933-.508 1.8-1.113 1.925-1.344.407-.746.266-1.55-.336-1.937-.48-.309-.699-.324-1.421-.09-.79.258-.891.238-1.274-.23-.387-.465-.422-1.079-.422-7.563 0-6.023.055-7.133.36-7.562.199-.278.562-.504.816-.504.504 0 12.707 6.804 13.414 7.48.848.809.258 1.332-3.883 3.457-2.105 1.086-3.851 1.969-3.875 1.969-.023 0-.011-.996.028-2.215.062-1.98.02-2.281-.422-2.832-.586-.734-1.371-.789-1.973-.137-.39.426-.437.856-.437 4.059 0 3.476.015 3.598.558 4.164.348.367.805.586 1.219.586.785 0 12.71-6.29 13.613-7.176l.586-.578.067 5.066c.035 2.786.066.172.066-5.804 0-5.977-.031-8.582-.066-5.793l-.067 5.078-.629-.586C22.02 10.262 17.547 7.75 12.426 5 2.012-.594 1.773-.68.594.695M.105 12.113c0 5.977.032 8.39.067 5.364.035-3.032.035-7.922 0-10.872-.035-2.949-.067-.468-.067 5.508m7.407-4c-.692.75-.301 2.239.613 2.328 1.445.145 2.223-1.093 1.406-2.238-.441-.625-1.488-.668-2.02-.09",
        fillRule: "evenodd",
        fill: "#04accc"
      }
    )
  );
}

// src/Apple.tsx
import * as React2 from "react";
var TITLE = "Apple";
function Apple() {
  return /* @__PURE__ */ React2.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE
    },
    /* @__PURE__ */ React2.createElement("title", null, TITLE),
    /* @__PURE__ */ React2.createElement(
      "path",
      {
        d: "M12.3789 6.61539C13.2816 6.61539 14.4132 6.00509 15.0871 5.19135C15.6974 4.45391 16.1424 3.42403 16.1424 2.39415C16.1424 2.25429 16.1297 2.11443 16.1043 2C15.0998 2.03814 13.8919 2.67387 13.1672 3.52575C12.595 4.17419 12.0737 5.19135 12.0737 6.23395C12.0737 6.38652 12.0992 6.5391 12.1119 6.58996C12.1755 6.60267 12.2772 6.61539 12.3789 6.61539Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React2.createElement(
      "path",
      {
        d: "M9.20025 22C10.4336 22 10.9803 21.1736 12.5188 21.1736C14.0826 21.1736 14.4259 21.9746 15.7991 21.9746C17.1469 21.9746 18.0496 20.7286 18.9015 19.508C19.8551 18.1094 20.2492 16.7362 20.2746 16.6726C20.1856 16.6472 17.6046 15.5919 17.6046 12.6294C17.6046 10.061 19.6389 8.90401 19.7533 8.81501C18.4056 6.8824 16.3585 6.83154 15.7991 6.83154C14.2861 6.83154 13.0528 7.74699 12.2772 7.74699C11.438 7.74699 10.3318 6.8824 9.02225 6.8824C6.5302 6.8824 4 8.94216 4 12.8328C4 15.2486 4.94088 17.8042 6.0979 19.4571C7.08964 20.8557 7.95423 22 9.20025 22Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Arrow.tsx
import * as React3 from "react";
var TRIANGLE_WIDTH = "24";
var TRIANGLE_HEIGHT = "24";
var SMALL_TRIANGLE_WIDTH = "12";
var SMALL_TRIANGLE_HEIGHT = "10";
var TRIANGLE_VIEWBOX = "0 0 24 24";
var SMALL_TRIANGLE_VIEWBOX = "0 0 24 20";
function ArrowLeft() {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      width: TRIANGLE_WIDTH,
      height: TRIANGLE_HEIGHT,
      viewBox: TRIANGLE_VIEWBOX,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Arrow Left",
      role: "img"
    },
    /* @__PURE__ */ React3.createElement("title", null, "Arrow Left"),
    /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M13.0753 19.7635L12.2871 20.5597L4 12.2799L12.2871 4L13.0753 4.79618L6.16186 11.7169H20V12.8428H6.16186L13.0753 19.7635Z",
        fill: "currentColor"
      }
    )
  );
}
function ArrowRight({ className }) {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      className,
      width: TRIANGLE_WIDTH,
      height: TRIANGLE_HEIGHT,
      viewBox: TRIANGLE_VIEWBOX,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Arrow Right",
      role: "img"
    },
    /* @__PURE__ */ React3.createElement("title", null, "Arrow Right"),
    /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M10.9247 19.7635L11.7129 20.5597L20 12.2799L11.7129 4L10.9247 4.79618L17.8381 11.7169H4V12.8428H17.8381L10.9247 19.7635Z",
        fill: "currentColor"
      }
    )
  );
}
function ArrowUp() {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      width: TRIANGLE_WIDTH,
      height: TRIANGLE_HEIGHT,
      viewBox: TRIANGLE_VIEWBOX,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Arrow Up"
    },
    /* @__PURE__ */ React3.createElement("title", null, "Arrow Up"),
    /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M19.4837 13.0753L20.2799 12.2871L12 4L3.72014 12.2871L4.51632 13.0753L11.437 6.16186L11.437 20L12.563 20L12.563 6.16186L19.4837 13.0753Z",
        fill: "currentColor"
      }
    )
  );
}
function ArrowDown() {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      width: TRIANGLE_WIDTH,
      height: TRIANGLE_HEIGHT,
      viewBox: TRIANGLE_VIEWBOX,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Arrow Down",
      role: "img"
    },
    /* @__PURE__ */ React3.createElement("title", null, "Arrow Down"),
    /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M4.51631 10.9247L3.72013 11.7129L12 20L20.2799 11.7129L19.4837 10.9247L12.563 17.8381L12.563 4L11.437 4L11.437 17.8381L4.51631 10.9247Z",
        fill: "currentColor"
      }
    )
  );
}
function TriangleLeft() {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      width: TRIANGLE_WIDTH,
      height: TRIANGLE_HEIGHT,
      viewBox: TRIANGLE_VIEWBOX,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Arrow Left"
    },
    /* @__PURE__ */ React3.createElement("title", null, "Arrow Left"),
    /* @__PURE__ */ React3.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 12L16 6L16 18L6 12Z",
        fill: "currentColor"
      }
    )
  );
}
function TriangleRight() {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      width: TRIANGLE_WIDTH,
      height: TRIANGLE_HEIGHT,
      viewBox: TRIANGLE_VIEWBOX,
      fill: "none",
      role: "img",
      "aria-label": "Arrow Right",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React3.createElement("title", null, "Arrow Right"),
    /* @__PURE__ */ React3.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 12L8 18L8 6L18 12Z",
        fill: "currentColor"
      }
    )
  );
}
function TriangleUp({
  small = false,
  className,
  width: explicitWidth,
  height: explicitHeight
}) {
  const defaultWidth = small ? SMALL_TRIANGLE_WIDTH : TRIANGLE_WIDTH;
  const defaultHeight = small ? SMALL_TRIANGLE_HEIGHT : TRIANGLE_HEIGHT;
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      className,
      width: explicitWidth || defaultWidth,
      height: explicitHeight || defaultHeight,
      viewBox: small ? SMALL_TRIANGLE_VIEWBOX : TRIANGLE_VIEWBOX,
      preserveAspectRatio: "xMidYMid meet",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Arrow Up"
    },
    /* @__PURE__ */ React3.createElement("title", null, "Arrow Up"),
    /* @__PURE__ */ React3.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: small ? "M12 0L24 20L0 20L12 0Z" : "M12 6L18 16L6 16L12 6Z",
        fill: "currentColor"
      }
    )
  );
}
function TriangleDown({
  small = false,
  className,
  width: explicitWidth,
  height: explicitHeight
}) {
  const defaultWidth = small ? SMALL_TRIANGLE_WIDTH : TRIANGLE_WIDTH;
  const defaultHeight = small ? SMALL_TRIANGLE_HEIGHT : TRIANGLE_HEIGHT;
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      className,
      width: explicitWidth || defaultWidth,
      height: explicitHeight || defaultHeight,
      viewBox: small ? SMALL_TRIANGLE_VIEWBOX : TRIANGLE_VIEWBOX,
      preserveAspectRatio: "xMidYMid meet",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Arrow Down",
      role: "img"
    },
    /* @__PURE__ */ React3.createElement("title", null, "Arrow Down"),
    /* @__PURE__ */ React3.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: small ? "M12 20L0 0L24 0L12 20Z" : "M12 18L6 8L18 8L12 18Z",
        fill: "currentColor"
      }
    )
  );
}

// src/BloombergLogo.tsx
import * as React4 from "react";
var TITLE2 = "Bloomberg";
function BloombergLogo() {
  return /* @__PURE__ */ React4.createElement(
    "svg",
    {
      width: "100%",
      height: "100%",
      version: "1.1",
      viewBox: "429.6 479.5 476.4 96.1",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      fill: "currentColor",
      "aria-label": TITLE2,
      "data-component": "bloombergLogo"
    },
    /* @__PURE__ */ React4.createElement("rect", { fill: "none", x: "429.5", y: "479.5", width: "480.2", height: "100.2" }),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m442.1 491.9h10.4c9.5 0 13.6 3 13.6 9.1 0 5.3-4.2 8.9-12.5 8.9h-11.4v-18zm-12.5 59.7h25.4c13.3 0 26.7-4.8 26.7-20.1 0-9.1-6.4-16-15.2-17v-0.2c7.3-2.2 12.2-7.5 12.2-15.4 0-12.8-10.9-17.7-21.6-17.7h-27.5v70.4zm12.5-31h12c10.2 0 14.9 2.6 14.9 10 0 9.3-9 10.4-15.4 10.4h-11.5v-20.4z"
      }
    ),
    /* @__PURE__ */ React4.createElement("path", { fill: "currentColor", d: "m489.8 479.5h11.9v72.1h-11.9v-72.1z" }),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m521.7 527.7c0-7.5 5.3-14.3 14-14.3 8.8 0 14 6.9 14 14.3 0 7.5-5.3 14.3-14 14.3-8.7 0.1-14-6.8-14-14.3zm-11.9 0c0 15 11.5 25.1 26 25.1 14.4 0 26-10.1 26-25.1s-11.5-25.1-26-25.1c-14.5 0.1-26 10.1-26 25.1z"
      }
    ),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m579.1 527.7c0-7.5 5.3-14.3 14-14.3 8.8 0 14 6.9 14 14.3 0 7.5-5.3 14.3-14 14.3-8.8 0.1-14-6.8-14-14.3zm-12 0c0 15 11.5 25.1 26 25.1 14.4 0 26-10.1 26-25.1s-11.5-25.1-26-25.1c-14.4 0.1-26 10.1-26 25.1z"
      }
    ),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m626.4 503.9h11.3v7.5h0.2c2.1-4.5 6.7-8.7 14.6-8.7 7.4 0 12.4 2.9 14.9 8.9 3.5-6.1 8.6-8.9 15.7-8.9 12.7 0 17.2 9.1 17.2 20.5v28.5h-11.9v-27.1c0-6-1.8-11.1-8.9-11.1-7.5 0-10.3 6.2-10.3 12.3v25.9h-11.9v-28.5c0-5.9-2.4-9.8-8.2-9.8-7.9 0-10.9 5.8-10.9 12.1v26.1h-11.9v-47.7z"
      }
    ),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m749.7 527.7c0 7.5-5.3 14.3-14 14.3-8.8 0-14-6.9-14-14.3 0-7.5 5.3-14.3 14-14.3s14 6.9 14 14.3zm-39.6 23.9h11.3v-7.2h0.2c3.5 5.8 9.8 8.4 16.4 8.4 14.7 0 23.6-10.9 23.6-25.1 0-14.1-9.5-25.1-23.1-25.1-9 0-13.7 4.2-16.2 7.3h-0.3v-30.4h-11.9v72.1z"
      }
    ),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m779 523c0.9-6.9 5.3-11.3 12.3-11.3 7.5 0 12 4.4 12.1 11.3h-24.4zm36.4 8.9v-3.3c0-16.6-9.1-26-22.4-26-14.4 0-26 10.1-26 25.1s11.5 25.1 26 25.1c7.6 0 14.6-2.7 20.2-9.6l-8.6-6.5c-3 3.7-6.9 6.5-12.8 6.5-6.7 0-12-4.3-12.8-11.3h36.4z"
      }
    ),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m823.2 503.9h11.9v7.6h0.2c2.6-5.5 7.9-8.8 14.1-8.8 1.5 0 2.9 0.3 4.3 0.7v11.5c-2-0.5-3.9-0.9-5.8-0.9-11.2 0-12.8 9.5-12.8 12v25.6h-11.9v-47.7z"
      }
    ),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m880.5 513.4c8.7 0 14.1 5.8 14.1 14 0 8-5.4 14-14.2 14-8.1 0-14-6.3-14-13.8 0-8.4 5.7-14.2 14.1-14.2zm14.1-9.5v7.2h-0.2c-3.5-5.8-9.8-8.4-16.4-8.4-14.7 0-23.6 11-23.6 25.1 0 13.5 9.5 24.5 23.8 24.5 6 0 12.1-2.3 15.6-7h0.2v3.5c0 9.5-3.6 16-15.1 16-6.7 0-11.6-2.5-16.4-6.9l-7.2 9.8c6.8 6 14.8 7.9 23.7 7.9 18.6 0 27-10.9 27-28.2v-43.5h-11.4z"
      }
    )
  );
}

// src/BloombergLogoSmall.tsx
import * as React5 from "react";
var TITLE3 = "Bloomberg";
function BloombergLogoSmall() {
  return /* @__PURE__ */ React5.createElement(
    "svg",
    {
      width: "90",
      height: "24",
      viewBox: "0 0 90 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE3,
      role: "img",
      "data-component": "bloombergLogoSmall"
    },
    /* @__PURE__ */ React5.createElement("rect", { width: "90", height: "24", fill: "white" }),
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M10.05 7.52844H11.6662C13.1308 7.52844 13.7874 7.98319 13.7874 8.94319C13.7874 9.75161 13.1308 10.3074 11.8682 10.3074H10.1006V7.52844H10.05ZM8.13086 16.7242H12.0702C14.141 16.7242 16.2117 15.9664 16.2117 13.6421C16.2117 12.2274 15.2016 11.1663 13.8884 11.0148C14.9995 10.6611 15.7571 9.80214 15.7571 8.58951C15.7571 6.61898 14.0904 5.86108 12.4238 5.86108H8.18138V16.7242H8.13086ZM10.05 11.9242H11.9187C13.4844 11.9242 14.242 12.3284 14.242 13.4905C14.242 14.9053 12.8783 15.1074 11.8682 15.1074H10.1006V11.9748L10.05 11.9242Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ React5.createElement("path", { d: "M17.4238 5.6084H19.2428V16.7242H17.4238V5.6084Z", fill: "black" }),
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M22.3738 13.0863C22.3738 11.9242 23.1819 10.8632 24.5456 10.8632C25.9092 10.8632 26.7173 11.9242 26.7173 13.0863C26.7173 14.2484 25.9092 15.3095 24.5456 15.3095C23.1819 15.3095 22.3738 14.2484 22.3738 13.0863ZM20.5557 13.0863C20.5557 15.4105 22.3233 16.9769 24.5456 16.9769C26.7678 16.9769 28.5355 15.4105 28.5355 13.0863C28.5355 10.7621 26.7678 9.1958 24.5456 9.1958C22.3233 9.1958 20.5557 10.7621 20.5557 13.0863Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M31.2115 13.0863C31.2115 11.9242 32.0196 10.8632 33.3832 10.8632C34.7468 10.8632 35.5549 11.9242 35.5549 13.0863C35.5549 14.2484 34.7468 15.3095 33.3832 15.3095C32.0196 15.3095 31.2115 14.2484 31.2115 13.0863ZM29.3428 13.0863C29.3428 15.4105 31.1105 16.9769 33.3327 16.9769C35.5549 16.9769 37.3226 15.4105 37.3226 13.0863C37.3226 10.7621 35.5549 9.1958 33.3327 9.1958C31.1105 9.1958 29.3428 10.7621 29.3428 13.0863Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M38.4844 9.39791H40.252V10.56C40.5551 9.85265 41.2621 9.1958 42.5248 9.1958C43.6864 9.1958 44.4439 9.65054 44.848 10.56C45.4035 9.60001 46.1611 9.1958 47.2722 9.1958C49.2419 9.1958 49.949 10.6105 49.949 12.379V16.7747H48.1308V12.5811C48.1308 11.6716 47.8783 10.8632 46.7672 10.8632C45.6056 10.8632 45.2015 11.8232 45.2015 12.7832V16.7747H43.3833V12.379C43.3833 11.4695 43.0298 10.8632 42.1207 10.8632C40.9086 10.8632 40.4541 11.7726 40.4541 12.7326V16.7747H38.6359V9.39791H38.4844Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M57.5252 13.0863C57.5252 14.2484 56.7171 15.3094 55.3534 15.3094C53.9898 15.3094 53.1817 14.2484 53.1817 13.0863C53.1817 11.9242 53.9898 10.8631 55.3534 10.8631C56.7171 10.8631 57.5252 11.9242 57.5252 13.0863ZM51.4141 16.7747H53.1817V15.6631C53.7373 16.5726 54.6969 16.9768 55.707 16.9768C57.9797 16.9768 59.3434 15.3094 59.3434 13.0863C59.3434 10.8631 57.8787 9.19576 55.7575 9.19576C54.3939 9.19576 53.6363 9.85261 53.2828 10.3073V5.6084H51.4646V16.7242L51.4141 16.7747Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M62.0711 12.3284C62.2226 11.2674 62.8792 10.56 63.9903 10.56C65.1519 10.56 65.859 11.2168 65.859 12.3284H62.0711ZM67.6772 13.6926V13.1874C67.6772 10.6105 66.263 9.1958 64.2428 9.1958C62.0206 9.1958 60.2529 10.7621 60.2529 13.0863C60.2529 15.4105 62.0206 16.9769 64.2428 16.9769C65.4044 16.9769 66.5155 16.5726 67.3741 15.5116L66.061 14.5011C65.6065 15.0568 65.0004 15.5116 64.0913 15.5116C63.0812 15.5116 62.2226 14.8548 62.1216 13.7432H67.7277L67.6772 13.6926Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M68.8884 9.39791H70.7066V10.56C71.1106 9.70107 71.9187 9.1958 72.8783 9.1958C73.1308 9.1958 73.3328 9.1958 73.5349 9.29686V11.0653C73.2318 10.9642 72.9288 10.9137 72.6258 10.9137C70.9086 10.9137 70.6561 12.379 70.6561 12.7832V16.7242H68.8379V9.34737L68.8884 9.39791Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M77.7272 10.8632C79.0908 10.8632 79.8989 11.7726 79.8989 13.0358C79.8989 14.299 79.0908 15.2084 77.7272 15.2084C76.4645 15.2084 75.5555 14.2484 75.5555 13.0863C75.5555 11.7726 76.414 10.9137 77.7272 10.9137V10.8632ZM79.8989 9.39791V10.5095C79.3434 9.6 78.3838 9.1958 77.3737 9.1958C75.1009 9.1958 73.7373 10.9137 73.7373 13.0863C73.7373 15.259 75.2019 16.8758 77.4242 16.8758C78.3332 16.8758 79.2928 16.5221 79.8484 15.8148V16.3705C79.8484 17.8358 79.2929 18.8463 77.5252 18.8463C76.5151 18.8463 75.7575 18.4421 74.9999 17.7853L73.8888 19.3011C74.9494 20.2105 76.1615 20.5137 77.5252 20.5137C80.404 20.5137 81.6666 18.8463 81.6666 16.1684V9.44843H79.8989V9.39791Z",
        fill: "black"
      }
    )
  );
}

// src/BloombergLogoUK.tsx
import * as React6 from "react";
var TITLE4 = "Bloomberg UK";
function BloombergLogoUK() {
  return /* @__PURE__ */ React6.createElement(
    "svg",
    {
      width: "100%",
      height: "100%",
      version: "1.0",
      viewBox: "329 600 638.93 96.1",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      fill: "currentColor",
      "aria-label": TITLE4,
      "data-component": "bloombergLogoUK"
    },
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m341.5 612.4h10.4c9.5 0 13.6 3 13.6 9.1 0 5.3-4.2 8.9-12.5 8.9h-11.4v-18h-0.1zm-12.5 59.7h25.4c13.3 0 26.7-4.8 26.7-20.1 0-9.1-6.4-16-15.2-17v-0.2c7.3-2.2 12.2-7.5 12.2-15.4 0-12.8-10.9-17.7-21.6-17.7h-27.5v70.4zm12.5-31h12c10.2 0 14.9 2.6 14.9 10 0 9.3-9 10.4-15.4 10.4h-11.5v-20.4z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement("path", { d: "m389.2 600h11.9v72.1h-11.9v-72.1z", fill: "currentColor" }),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m421.1 648.2c0-7.5 5.3-14.3 14-14.3 8.8 0 14 6.9 14 14.3 0 7.5-5.3 14.3-14 14.3-8.7 0.1-14-6.8-14-14.3zm-11.9 0c0 15 11.5 25.1 26 25.1 14.4 0 26-10.1 26-25.1s-11.5-25.1-26-25.1c-14.5 0.1-26 10.1-26 25.1z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m478.5 648.2c0-7.5 5.3-14.3 14-14.3 8.8 0 14 6.9 14 14.3 0 7.5-5.3 14.3-14 14.3-8.8 0.1-14-6.8-14-14.3zm-12 0c0 15 11.5 25.1 26 25.1 14.4 0 26-10.1 26-25.1s-11.5-25.1-26-25.1c-14.4 0.1-26 10.1-26 25.1z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m525.8 624.4h11.3v7.5h0.2c2.1-4.5 6.7-8.7 14.6-8.7 7.4 0 12.4 2.9 14.9 8.9 3.5-6.1 8.6-8.9 15.7-8.9 12.7 0 17.2 9.1 17.2 20.5v28.5h-11.9v-27.1c0-6-1.8-11.1-8.9-11.1-7.5 0-10.3 6.2-10.3 12.3v25.9h-11.9v-28.5c0-5.9-2.4-9.8-8.2-9.8-7.9 0-10.9 5.8-10.9 12.1v26.1h-11.9v-47.7h0.1z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m649.1 648.2c0 7.5-5.3 14.3-14 14.3-8.8 0-14-6.9-14-14.3 0-7.5 5.3-14.3 14-14.3s14 6.9 14 14.3zm-39.6 23.9h11.3v-7.2h0.2c3.5 5.8 9.8 8.4 16.4 8.4 14.7 0 23.6-10.9 23.6-25.1 0-14.1-9.5-25.1-23.1-25.1-9 0-13.7 4.2-16.2 7.3h-0.3v-30.4h-11.9v72.1z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m678.4 643.5c0.9-6.9 5.3-11.3 12.3-11.3 7.5 0 12 4.4 12.1 11.3h-24.4zm36.4 8.9v-3.3c0-16.6-9.1-26-22.4-26-14.4 0-26 10.1-26 25.1s11.5 25.1 26 25.1c7.6 0 14.6-2.7 20.2-9.6l-8.6-6.5c-3 3.7-6.9 6.5-12.8 6.5-6.7 0-12-4.3-12.8-11.3h36.4z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m722.6 624.4h11.9v7.6h0.2c2.6-5.5 7.9-8.8 14.1-8.8 1.5 0 2.9 0.3 4.3 0.7v11.5c-2-0.5-3.9-0.9-5.8-0.9-11.2 0-12.8 9.5-12.8 12v25.6h-11.9v-47.7z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m779.9 633.9c8.7 0 14.1 5.8 14.1 14 0 8-5.4 14-14.2 14-8.1 0-14-6.3-14-13.8 0-8.4 5.7-14.2 14.1-14.2zm14.1-9.5v7.2h-0.2c-3.5-5.8-9.8-8.4-16.4-8.4-14.7 0-23.6 11-23.6 25.1 0 13.5 9.5 24.5 23.8 24.5 6 0 12.1-2.3 15.6-7h0.2v3.5c0 9.5-3.6 16-15.1 16-6.7 0-11.6-2.5-16.4-6.9l-7.2 9.8c6.8 6 14.8 7.9 23.7 7.9 18.6 0 27-10.9 27-28.2v-43.5h-11.4z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m895.48 647.47c0 4.108-0.706 7.83-2.118 11.167-1.412 3.273-3.337 6.065-5.776 8.375-2.438 2.311-5.326 4.108-8.664 5.391-3.337 1.22-6.963 1.83-10.878 1.83s-7.541-0.61-10.878-1.83c-3.337-1.283-6.257-3.08-8.76-5.391-2.439-2.31-4.364-5.102-5.776-8.375-1.348-3.337-2.022-7.059-2.022-11.167v-43.127h12.13v42.646c0 1.99 0.256 3.979 0.77 5.969 0.513 1.925 1.348 3.658 2.503 5.198 1.219 1.54 2.791 2.792 4.717 3.754 1.989 0.963 4.428 1.444 7.316 1.444s5.295-0.481 7.22-1.444c1.99-0.962 3.562-2.214 4.717-3.754 1.22-1.54 2.086-3.273 2.599-5.198 0.514-1.99 0.771-3.979 0.771-5.969v-42.646h12.129v43.127z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "m908.54 604.34h12.13v29.457h0.289l28.495-29.457h16.365l-31.864 31.479 33.982 36.678h-17.039l-29.939-34.175h-0.289v34.175h-12.13v-68.157z",
        fill: "currentColor"
      }
    )
  );
}

// src/BloombergLogoWeekend.tsx
import * as React7 from "react";
var TITLE5 = "Bloomberg Weekend";
function BloombergLogoWeekend() {
  return /* @__PURE__ */ React7.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      fill: "currentColor",
      "aria-label": TITLE5,
      "data-component": "bloombergLogoWeekend",
      width: "100%",
      height: "100%",
      viewBox: "0 0 756 80"
    },
    /* @__PURE__ */ React7.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M10.433 10.32h8.657c7.909 0 11.321 2.498 11.321 7.576 0 4.411-3.496 7.409-10.405 7.409h-9.489V10.32zM.03 60.017h21.143c11.07 0 22.225-3.996 22.225-16.732 0-7.575-5.328-13.318-12.653-14.151v-.166c6.077-1.832 10.155-6.243 10.155-12.82 0-10.654-9.073-14.733-17.98-14.733H.03zM10.433 34.21h9.99c8.49 0 12.403 2.164 12.403 8.324 0 7.741-7.492 8.657-12.82 8.657h-9.573zM50.11 0h9.904v60.016H50.11zM76.68 40.131c0-6.243 4.411-11.903 11.653-11.903 7.325 0 11.654 5.743 11.654 11.903 0 6.243-4.412 11.904-11.654 11.904-7.242.083-11.653-5.66-11.653-11.904m-9.906 0c0 12.486 9.572 20.893 21.643 20.893 11.986 0 21.641-8.407 21.641-20.893 0-12.485-9.571-20.893-21.642-20.893-12.07.083-21.642 8.408-21.642 20.893M124.459 40.131c0-6.243 4.412-11.903 11.653-11.903 7.326 0 11.654 5.743 11.654 11.903 0 6.243-4.411 11.904-11.654 11.904-7.325.083-11.653-5.66-11.653-11.904m-9.989 0c0 12.486 9.573 20.893 21.642 20.893 11.988 0 21.643-8.407 21.643-20.893 0-12.485-9.573-20.893-21.643-20.893-11.986.083-21.642 8.408-21.642 20.893M163.861 20.316h9.407v6.243h.166c1.748-3.745 5.577-7.241 12.154-7.241 6.159 0 10.321 2.414 12.402 7.408 2.914-5.078 7.159-7.408 13.069-7.408 10.572 0 14.317 7.575 14.317 17.064v23.723h-9.906V37.548c0-4.995-1.498-9.24-7.407-9.24-6.244 0-8.575 5.16-8.575 10.238v21.56h-9.905V36.381c0-4.911-1.998-8.157-6.826-8.157-6.576 0-9.073 4.827-9.073 10.071v21.726h-9.905V20.316zM266.476 40.121c0 6.243-4.413 11.904-11.654 11.904-7.325 0-11.654-5.743-11.654-11.904 0-6.242 4.411-11.903 11.654-11.903 7.241 0 11.654 5.744 11.654 11.903m-32.964 19.895h9.406v-5.993h.167c2.914 4.828 8.157 6.993 13.651 6.993 12.236 0 19.645-9.074 19.645-20.895 0-11.736-7.907-20.893-19.229-20.893-7.491 0-11.403 3.497-13.485 6.077h-.249V0h-9.906zM290.885 36.22c.749-5.744 4.412-9.407 10.238-9.407 6.243 0 9.989 3.663 10.072 9.406zm30.299 7.408V40.88c0-13.818-7.575-21.642-18.645-21.642-11.987 0-21.643 8.408-21.643 20.893s9.572 20.893 21.643 20.893c6.326 0 12.152-2.246 16.814-7.99l-7.158-5.41c-2.498 3.079-5.745 5.41-10.655 5.41-5.577 0-9.99-3.58-10.655-9.406zM327.653 20.316h9.905v6.327h.166c2.165-4.579 6.577-7.325 11.738-7.325 1.248 0 2.413.25 3.579.582v9.573c-1.665-.416-3.247-.75-4.828-.75-9.323 0-10.655 7.909-10.655 9.99v21.31h-9.905zM375.362 28.225c7.243 0 11.737 4.827 11.737 11.653 0 6.659-4.494 11.654-11.819 11.654-6.743 0-11.654-5.245-11.654-11.488 0-6.992 4.745-11.82 11.736-11.82m11.737-7.909v5.994h-.166c-2.914-4.828-8.157-6.992-13.652-6.992-12.235 0-19.644 9.156-19.644 20.893 0 11.237 7.907 20.394 19.811 20.394 4.994 0 10.072-1.914 12.985-5.827h.167v2.913c0 7.909-2.997 13.319-12.569 13.319-5.578 0-9.656-2.08-13.651-5.744l-5.994 8.157c5.66 4.995 12.319 6.577 19.728 6.577 15.483 0 22.475-9.073 22.475-23.474v-36.21zM755.914 60.022h-9.534V54.65h-.168c-2.76 4.6-8.196 5.955-13.8 5.955-12.212 0-19.739-8.465-19.739-20.174 0-11.877 8.029-21.077 19.488-21.077 7.36 0 11.375 3.68 13.466 6.273h.251V0h10.036zm-21.495-6.543c7.36 0 11.793-6.608 11.793-12.88 0-6.274-4.433-13.048-11.793-13.048-7.778 0-11.542 6.607-11.542 12.88s3.764 13.048 11.542 13.048M707.903 60.022h-10.037V38.424c0-4.768-1.087-10.706-7.528-10.706-6.356 0-9.367 5.52-9.367 10.873v21.431h-10.037V20.525h9.535v6.44h.167c1.757-4.015 6.524-7.611 12.463-7.611 10.454 0 14.804 8.03 14.804 16.226zM634.15 36.335c.749-5.743 4.412-9.406 10.239-9.406 6.243 0 9.988 3.663 10.072 9.406zm30.3 7.409v-2.748c0-13.818-7.575-21.642-18.646-21.642-11.987 0-21.643 8.408-21.643 20.893s9.573 20.893 21.643 20.893c6.327 0 12.153-2.246 16.814-7.99l-7.158-5.41c-2.497 3.08-5.744 5.41-10.655 5.41-5.577 0-9.989-3.58-10.655-9.406z"
      }
    ),
    /* @__PURE__ */ React7.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M625.801 60.022h-13.298l-15.366-19.926h-.251v19.926H586.85V0h10.036v37.42h.251l14.697-16.895h12.88l-17.397 18.15zM550.064 36.335c.75-5.743 4.413-9.406 10.239-9.406 6.243 0 9.989 3.663 10.072 9.406zm30.3 7.409v-2.748c0-13.818-7.575-21.642-18.646-21.642-11.986 0-21.642 8.408-21.642 20.893s9.572 20.893 21.642 20.893c6.327 0 12.153-2.246 16.815-7.99l-7.158-5.41c-2.498 3.08-5.745 5.41-10.655 5.41-5.577 0-9.99-3.58-10.656-9.406zM505.37 36.335c.75-5.743 4.413-9.406 10.239-9.406 6.243 0 9.989 3.663 10.072 9.406zm30.3 7.409v-2.748c0-13.818-7.575-21.642-18.646-21.642-11.986 0-21.642 8.408-21.642 20.893s9.572 20.893 21.642 20.893c6.327 0 12.153-2.246 16.815-7.99l-7.158-5.41c-2.498 3.08-5.745 5.41-10.655 5.41-5.577 0-9.99-3.58-10.656-9.406zM480.513 60.022h-10.204L456.424 16.26h-.167l-13.884 43.763h-10.204L414.856 1.455h11.542l11.459 43.492h.167l13.048-43.492h10.873l12.797 43.492h.167l11.709-43.492h11.208z"
      }
    )
  );
}

// src/Bookmark.tsx
import * as React8 from "react";
var TITLE6 = "Bookmark";
function BookmarkStroke() {
  return /* @__PURE__ */ React8.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE6
    },
    /* @__PURE__ */ React8.createElement("title", null, TITLE6),
    /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M11.6609 15.6326L6 20.858V2.5H18V20.858L12.3391 15.6326L12 15.3195L11.6609 15.6326Z",
        stroke: "currentColor"
      }
    )
  );
}
function BookmarkFilled() {
  return /* @__PURE__ */ React8.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE6
    },
    /* @__PURE__ */ React8.createElement("title", null, TITLE6),
    /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M11.6609 15.6326L6 20.858V2.5H18V20.858L12.3391 15.6326L12 15.3195L11.6609 15.6326Z",
        fill: "currentColor",
        stroke: "currentColor"
      }
    )
  );
}

// src/BusinessweekLogo.tsx
import * as React9 from "react";
var TITLE7 = "Bloomberg Businessweek";
function BusinessweekLogo() {
  return /* @__PURE__ */ React9.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "404px",
      height: "101px",
      viewBox: "0 0 404 101",
      version: "1.1",
      role: "img",
      fill: "currentColor",
      "aria-label": TITLE7,
      "data-component": "businessweekLogo"
    },
    /* @__PURE__ */ React9.createElement("title", null, TITLE7),
    /* @__PURE__ */ React9.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React9.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React9.createElement("path", { d: "M20.3827026,18.3087244 C22.8300192,18.3087244 24.6051939,16.9443726 24.6051939,14.2132349 C24.6051939,11.5441685 22.7688062,10.240671 20.3214896,10.240671 L12.5486489,10.240671 L12.5486489,18.3087244 L20.3827026,18.3087244 Z M21.5457481,36.4323302 C24.3003295,36.4323302 26.3179554,34.7564048 26.3179554,31.6540563 C26.3179554,28.4263481 24.1142903,26.8745653 21.4845352,26.8745653 L12.5486489,26.8745653 L12.5486489,36.4323302 L21.5457481,36.4323302 Z M0,0.000121708454 L22.6475807,0.000121708454 C26.9300846,0.000121708454 30.2355824,1.055334 32.5628737,2.97954465 C35.193829,5.15082346 36.6029265,8.37974873 36.6029265,12.226953 C36.6029265,16.6960874 34.8277518,19.4892964 31.1549765,21.226076 L31.1549765,21.413507 C35.9295843,23.026144 38.6817653,27.3699187 38.6817653,32.6459802 C38.6817653,37.6737564 36.785365,41.5830319 33.6623057,43.9429589 C31.0325506,45.8671695 27.6058273,46.7970221 23.0760711,46.7970221 L0,46.7970221 L0,0.000121708454 Z M40.7685258,46.7981175 L40.7685258,0 L52.6426323,0 L52.6426323,46.7981175 L40.7685258,46.7981175 Z M77.3103594,30.1634929 C77.3103594,24.3300067 75.4727715,20.6677993 71.9236223,20.6677993 C68.3744731,20.6677993 66.6605113,24.3300067 66.6605113,30.1634929 C66.6605113,36.0602674 68.3744731,39.7224748 71.9236223,39.7224748 C75.4727715,39.7224748 77.3103594,36.0602674 77.3103594,30.1634929 M54.9088307,30.1634929 C54.9088307,19.612587 61.6410518,12.4756033 72.0448479,12.4756033 C82.4510445,12.4756033 89.06204,19.612587 89.06204,30.1634929 C89.06204,40.7776871 82.4510445,47.8513824 72.0448479,47.8513824 C61.6410518,47.8513824 54.9088307,40.7776871 54.9088307,30.1634929 M112.813974,30.1634929 C112.813974,24.3300067 110.976386,20.6677993 107.427237,20.6677993 C103.878088,20.6677993 102.164126,24.3300067 102.164126,30.1634929 C102.164126,36.0602674 103.878088,39.7224748 107.427237,39.7224748 C110.976386,39.7224748 112.813974,36.0602674 112.813974,30.1634929 M90.4124451,30.1634929 C90.4124451,19.612587 97.1446662,12.4756033 107.548462,12.4756033 C117.954659,12.4756033 124.565654,19.612587 124.565654,30.1634929 C124.565654,40.7776871 117.954659,47.8513824 107.548462,47.8513824 C97.1446662,47.8513824 90.4124451,40.7776871 90.4124451,30.1634929 Z M126.832573,13.4071598 L137.850899,13.4071598 L137.850899,18.433719 L138.033337,18.433719 C140.237003,14.5232263 143.235235,12.4140188 147.949831,12.4140188 C152.111109,12.4140188 155.232968,14.5232263 156.824504,18.1854337 L157.008143,18.1854337 C159.701511,13.7783706 163.189448,12.4140188 167.2283,12.4140188 C174.879915,12.4140188 178.185413,18.1233624 178.185413,25.8189879 L178.185413,46.7978741 L166.616171,46.7978741 L166.616171,27.9294125 C166.616171,24.5154904 165.575551,22.2809232 162.638531,22.2809232 C159.762724,22.2809232 158.292414,25.0120609 158.292414,28.6121969 L158.292414,46.7978741 L146.725572,46.7978741 L146.725572,27.9294125 C146.725572,24.5154904 145.684953,22.2809232 142.747933,22.2809232 C139.868525,22.2809232 138.401815,25.0120609 138.401815,28.6121969 L138.401815,46.7978741 L126.832573,46.7978741 L126.832573,13.4071598 Z M203.594897,29.9161813 C203.594897,24.5159772 201.637283,21.0399838 198.146947,21.0399838 C194.597797,21.0399838 192.332919,24.5159772 192.332919,29.9161813 C192.332919,35.253097 194.597797,38.7911617 198.146947,38.7911617 C201.698496,38.7911617 203.594897,35.3151683 203.594897,29.9161813 M192.332919,42.4533691 L192.211694,42.4533691 L192.211694,46.7971438 L181.193368,46.7971438 L181.193368,0.000243416907 L192.76261,0.000243416907 L192.76261,16.882423 L192.945049,16.882423 C195.148714,13.9662885 198.085734,12.4132886 202.310626,12.4132886 C210.57317,12.4132886 215.346577,19.9847715 215.346577,30.0403239 C215.346577,41.3981568 210.144679,47.9144274 201.576071,47.9144274 C198.024521,47.9144274 194.354146,46.1764307 192.332919,42.4533691 M228.326597,26.5644522 L238.85522,26.5644522 C238.66918,22.531034 236.465515,20.4193924 233.710934,20.4193924 C230.530262,20.4193924 228.755088,22.7160309 228.326597,26.5644522 M216.818568,30.0392285 C216.818568,19.6124653 223.612002,12.351339 233.467282,12.351339 C238.364316,12.351339 242.159517,13.9031218 245.036525,16.6963308 C248.831726,20.4193924 250.545687,26.2528786 250.420861,33.1427941 L228.326597,33.1427941 C228.816301,37.301572 230.773914,39.4119965 234.26185,39.4119965 C236.283077,39.4119965 238.057051,38.4809269 238.794007,36.2463597 L249.931158,36.2463597 C247.973545,43.8799139 242.159517,47.7283352 233.896973,47.7283352 C223.675615,47.7283352 216.818568,40.7154941 216.818568,30.0392285 Z M263.218323,19.1169902 L263.400761,19.1169902 C265.788065,14.4616419 268.909924,12.7236451 272.888764,12.7236451 C273.804557,12.7236451 274.419087,12.8490049 274.785164,13.0340017 L274.785164,23.274551 L274.541513,23.274551 C267.746878,22.0343418 263.769239,25.3241213 263.769239,32.8335329 L263.769239,46.7971438 L252.199997,46.7971438 L252.199997,13.4076467 L263.218323,13.4076467 L263.218323,19.1169902 Z M297.432625,28.8608473 C297.432625,24.7020694 295.475012,21.3514357 292.109501,21.3514357 C288.864016,21.3514357 286.782777,24.3296416 286.782777,28.8608473 C286.782777,33.3299817 288.864016,36.5564728 292.109501,36.5564728 C295.475012,36.5564728 297.432625,33.2679104 297.432625,28.8608473 M276.132929,46.8590934 L287.27248,46.8590934 C287.702171,48.2867336 289.171281,49.7155908 291.925862,49.7155908 C295.65865,49.7155908 296.945322,47.3556639 296.945322,43.8796705 L296.945322,41.3980351 L296.69927,41.3980351 C294.862882,43.570531 292.413165,45.1843851 288.804003,45.1843851 C281.703304,45.1843851 275.520799,39.8450352 275.520799,29.4194891 C275.520799,19.8605072 280.601472,12.4131669 288.253087,12.4131669 C292.659217,12.4131669 295.353786,14.2132349 297.12776,17.0685152 L297.310199,17.0685152 L297.310199,13.4075249 L308.328525,13.4075249 L308.328525,42.3278877 C308.328525,47.6660205 306.493337,51.8247983 303.738756,54.3088678 C300.861749,56.9134288 296.760483,57.9698581 292.109501,57.9698581 C283.356053,57.9698581 277.234761,54.3088678 276.132929,46.8590934 M20.3827026,71.3952706 C22.8300192,71.3952706 24.6051939,70.0284847 24.6051939,67.297347 C24.6051939,64.6294977 22.7688062,63.3247831 20.3214896,63.3247831 L12.5486489,63.3247831 L12.5486489,71.3952706 L20.3827026,71.3952706 Z M21.5457481,89.5188765 C24.3003295,89.5188765 26.3179554,87.842951 26.3179554,84.7381684 C26.3179554,81.5104602 24.1142903,79.9598945 21.4845352,79.9598945 L12.5486489,79.9598945 L12.5486489,89.5188765 L21.5457481,89.5188765 Z M0,53.0842338 L22.6475807,53.0842338 C26.9300846,53.0842338 30.2355824,54.1394461 32.5628737,56.0648738 C35.193829,58.2349356 36.6029265,61.4638608 36.6029265,65.3122821 C36.6029265,69.7814165 34.8277518,72.5746256 31.1549765,74.3126223 L31.1549765,74.4976191 C35.9295843,76.1114732 38.6817653,80.456465 38.6817653,85.7313094 C38.6817653,90.7590856 36.785365,94.6695782 33.6623057,97.028288 C31.0325506,98.9512816 27.6058273,99.8823513 23.0760711,99.8823513 L0,99.8823513 L0,53.0842338 Z M61.5781585,99.8825947 L61.5781585,95.5376029 L61.39572,95.5376029 C59.0060155,99.0123792 55.94777,100.937807 51.6616652,100.937807 C44.1960893,100.937807 40.5221138,95.7250339 40.5221138,88.0281913 L40.5221138,66.4906634 L52.0913559,66.4906634 L52.0913559,85.4199792 C52.0913559,89.2075462 53.5004534,90.6972577 56.2538346,90.6972577 C59.2532677,90.6972577 61.0272422,88.6489044 61.0272422,84.799266 L61.0272422,66.4906634 L72.5964843,66.4906634 L72.5964843,99.8825947 L61.5781585,99.8825947 Z M74.4339522,89.3305935 L85.1474137,89.3305935 C85.3298522,92.0617312 86.9213882,93.6755853 89.8596084,93.6755853 C92.1232862,93.6755853 93.837248,92.9940179 93.837248,90.6973794 C93.837248,87.9662417 90.2268859,87.7812449 86.1856328,87.0960263 C80.9225219,86.2903163 74.8624426,84.5523196 74.8624426,76.1739096 C74.8624426,69.3460654 81.4122252,65.4976441 89.0638404,65.4976441 C98.5518432,65.4976441 103.507689,69.2839941 103.93618,75.8002647 L93.0426803,75.8002647 C92.7354154,73.3186293 91.0214536,72.6358449 89.1250533,72.6358449 C87.4122918,72.6358449 85.8195556,73.3186293 85.8195556,75.2416229 C85.8195556,77.1049793 88.6965629,77.6015498 92.2457121,78.0969032 C97.9373135,78.9659016 105.160438,80.3302533 105.160438,89.5800958 C105.160438,97.5860779 98.3658039,101 89.7983955,101 C80.5552443,101 74.4975656,96.9653648 74.4339522,89.3305935 Z M107.060919,63.821597 L118.630162,63.821597 L118.630162,54.4512632 L107.060919,54.4512632 L107.060919,63.821597 Z M107.060919,99.8825947 L107.060919,66.4906634 L118.630162,66.4906634 L118.630162,99.8825947 L107.060919,99.8825947 Z M132.894813,71.0838187 L133.077251,71.0838187 C135.588181,67.4228284 138.771253,65.4974007 143.11617,65.4974007 C150.338095,65.4974007 154.072083,70.6493195 154.072083,78.2840908 L154.072083,99.882473 L142.504041,99.882473 L142.504041,81.0152285 C142.504041,77.2909498 141.158557,75.2413795 138.157924,75.2413795 C135.219703,75.2413795 133.445729,77.725449 133.445729,81.5738703 L133.445729,99.882473 L121.876487,99.882473 L121.876487,66.4917588 L132.894813,66.4917588 L132.894813,71.0838187 Z M167.601339,79.6485643 L178.128761,79.6485643 C177.946323,75.6151461 175.742657,73.5035045 172.988076,73.5035045 C169.805004,73.5035045 168.029829,75.800143 167.601339,79.6485643 M156.09571,83.1233406 C156.09571,72.6977945 162.889144,65.4354511 172.744424,65.4354511 C177.639058,65.4354511 181.434259,66.988451 184.311266,69.78166 C188.106467,73.5035045 189.820429,79.3394248 189.698003,86.2281233 L167.601339,86.2281233 C168.091042,90.3856841 170.051056,92.4973257 173.538992,92.4973257 C175.560219,92.4973257 177.334193,91.565039 178.068748,89.3304718 L189.2083,89.3304718 C187.248286,96.9664601 181.434259,100.814881 173.171715,100.814881 C162.950357,100.814881 156.09571,93.7996062 156.09571,83.1233406 Z M190.856248,89.3305935 L201.567309,89.3305935 C201.752148,92.0617312 203.343684,93.6755853 206.281904,93.6755853 C208.545582,93.6755853 210.259543,92.9940179 210.259543,90.6973794 C210.259543,87.9662417 206.646781,87.7812449 202.607928,87.0960263 C197.344817,86.2903163 191.284738,84.5523196 191.284738,76.1739096 C191.284738,69.3460654 197.834521,65.4976441 205.484936,65.4976441 C214.971738,65.4976441 219.929985,69.2839941 220.358475,75.8002647 L209.462575,75.8002647 C209.157711,73.3186293 207.443749,72.6358449 205.544948,72.6358449 C203.830987,72.6358449 202.241851,73.3186293 202.241851,75.2416229 C202.241851,77.1049793 205.118858,77.6015498 208.668008,78.0969032 C214.359609,78.9659016 221.582734,80.3302533 221.582734,89.5800958 C221.582734,97.5860779 214.788099,101 206.220691,101 C196.97754,101 190.917461,96.9653648 190.856248,89.3305935 Z M222.812993,89.3305935 L233.524054,89.3305935 C233.708893,92.0617312 235.300429,93.6755853 238.23865,93.6755853 C240.502327,93.6755853 242.216289,92.9940179 242.216289,90.6973794 C242.216289,87.9662417 238.603527,87.7812449 234.564674,87.0960263 C229.301563,86.2903163 223.241484,84.5523196 223.241484,76.1739096 C223.241484,69.3460654 229.791266,65.4976441 237.441681,65.4976441 C246.928484,65.4976441 251.886731,69.2839941 252.315221,75.8002647 L241.419321,75.8002647 C241.114457,73.3186293 239.400495,72.6358449 237.501694,72.6358449 C235.787732,72.6358449 234.198597,73.3186293 234.198597,75.2416229 C234.198597,77.1049793 237.075604,77.6015498 240.624753,78.0969032 C246.316355,78.9659016 253.539479,80.3302533 253.539479,89.5800958 C253.539479,97.5860779 246.744845,101 238.177437,101 C228.934286,101 222.874206,96.9653648 222.812993,89.3305935 Z M290.939494,66.4911502 L302.507536,66.4911502 L292.592243,99.8830815 L281.451491,99.8830815 L276.984148,80.3951239 L276.861722,80.3951239 L272.394379,99.8830815 L261.436066,99.8830815 L251.45956,66.4911502 L263.272454,66.4911502 L267.740997,84.7376816 L267.864623,84.7376816 L272.085914,66.4911502 L282.124833,66.4911502 L286.348525,84.8618242 L286.470951,84.8618242 L290.939494,66.4911502 Z M312.060713,79.6485643 L322.586935,79.6485643 C322.403296,75.6151461 320.199631,73.5035045 317.445049,73.5035045 C314.264378,73.5035045 312.486803,75.800143 312.060713,79.6485643 M300.552683,83.1233406 C300.552683,72.6977945 307.346117,65.4354511 317.201398,65.4354511 C322.096031,65.4354511 325.891232,66.988451 328.768239,69.78166 C332.563441,73.5035045 334.277402,79.3394248 334.154976,86.2281233 L312.060713,86.2281233 C312.548015,90.3856841 314.508029,92.4973257 317.995965,92.4973257 C320.017192,92.4973257 321.791167,91.565039 322.525722,89.3304718 L333.665273,89.3304718 C331.70766,96.9664601 325.891232,100.814881 317.631088,100.814881 C307.40733,100.814881 300.552683,93.7996062 300.552683,83.1233406 M347.01101,79.6485643 L357.538432,79.6485643 C357.355994,75.6151461 355.152329,73.5035045 352.397747,73.5035045 C349.214675,73.5035045 347.439501,75.800143 347.01101,79.6485643 M335.505382,83.1233406 C335.505382,72.6977945 342.298816,65.4354511 352.151695,65.4354511 C357.048729,65.4354511 360.84393,66.988451 363.720938,69.78166 C367.516139,73.5035045 369.2301,79.3394248 369.107675,86.2281233 L347.01101,86.2281233 C347.500714,90.3856841 349.460727,92.4973257 352.948664,92.4973257 C354.96749,92.4973257 356.743865,91.565039 357.47842,89.3304718 L368.617971,89.3304718 C366.657958,96.9664601 360.84393,100.814881 352.581386,100.814881 C342.360028,100.814881 335.505382,93.7996062 335.505382,83.1233406 Z M370.88501,53.0848423 L382.270613,53.0848423 L382.270613,76.6707236 L390.043454,66.4910285 L402.773341,66.4910285 L392.369545,78.8420024 L404,99.8829598 L390.899235,99.8829598 L384.656717,87.7157657 L382.270613,90.5089747 L382.270613,99.8829598 L370.88501,99.8829598 L370.88501,53.0848423 Z" })))
  );
}

// src/Checkmark.tsx
import * as React10 from "react";
var TITLE8 = "Checkmark";
function CheckmarkStroke({ className, title }) {
  return /* @__PURE__ */ React10.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": title || TITLE8
    },
    /* @__PURE__ */ React10.createElement("title", null, title || TITLE8),
    /* @__PURE__ */ React10.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10.126 18.0042L18 8.03048L16.4921 6.84L9.95682 15.118L7.35852 12.5197L6 13.8782L10.126 18.0042Z",
        fill: "currentColor"
      }
    )
  );
}
function CheckmarkFilled({ className, title }) {
  return /* @__PURE__ */ React10.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE8
    },
    /* @__PURE__ */ React10.createElement("title", null, title || TITLE8),
    /* @__PURE__ */ React10.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.126 18.0042L18 8.03048L16.4921 6.84L9.95682 15.118L7.35852 12.5197L6 13.8782L10.126 18.0042Z",
        fill: "currentColor"
      }
    )
  );
}
function Checkmark({ className, title }) {
  const _title = title || TITLE8;
  return /* @__PURE__ */ React10.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      "aria-label": _title,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React10.createElement("title", null, _title),
    /* @__PURE__ */ React10.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 4.68064L8.87668 21.3035L2 14.4268L4.26419 12.1626L8.59469 16.4931L19.4868 2.6965L22 4.68064Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Chevron.tsx
import * as React11 from "react";
function ChevronLeft() {
  return /* @__PURE__ */ React11.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Chevron Left",
      role: "img"
    },
    /* @__PURE__ */ React11.createElement("title", null, "Chevron Left"),
    /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M8.92155 11.9954L16.46 19.5387L14.9977 21L5.99798 11.9945L14.9982 3L16.4595 4.46225L8.92155 11.9954Z",
        fill: "currentColor"
      }
    )
  );
}
function ChevronRight() {
  return /* @__PURE__ */ React11.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Chevron Right"
    },
    /* @__PURE__ */ React11.createElement("title", null, "Chevron Right"),
    /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M15.0784 12.0046L7.54 4.46132L9.00225 3L18.002 12.0055L9.00178 21L7.54047 19.5377L15.0784 12.0046Z",
        fill: "currentColor"
      }
    )
  );
}
function ChevronUp() {
  return /* @__PURE__ */ React11.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Chevron Up",
      role: "img"
    },
    /* @__PURE__ */ React11.createElement("title", null, "Chevron Up"),
    /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M12.0046 8.92154L4.46132 16.46L3 14.9977L12.0055 5.99797L21 14.9982L19.5377 16.4595L12.0046 8.92154Z",
        fill: "currentColor"
      }
    )
  );
}
function ChevronDown(props) {
  const { title = "Chevron Down" } = props;
  return /* @__PURE__ */ React11.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": title,
      role: "img"
    },
    /* @__PURE__ */ React11.createElement("title", null, title),
    /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M11.9954 15.0785L19.5387 7.54001L21 9.00226L11.9945 18.002L3 9.00179L4.46225 7.54047L11.9954 15.0785Z",
        fill: "currentColor"
      }
    )
  );
}
function ChevronLeftThin() {
  return /* @__PURE__ */ React11.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Chevron Left",
      role: "img"
    },
    /* @__PURE__ */ React11.createElement("title", null, "Chevron Left"),
    /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M7.52511 12.0051L15.7627 3.76231L14.9999 3L6 12.0056L15.0001 21L15.7624 20.2372L7.52511 12.0051Z",
        fill: "currentColor"
      }
    )
  );
}
function ChevronRightThin() {
  return /* @__PURE__ */ React11.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Chevron Right"
    },
    /* @__PURE__ */ React11.createElement("title", null, "Chevron Right"),
    /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M16.4749 12.0051L8.23732 3.76231L9.00012 3L18 12.0056L8.99988 21L8.23757 20.2372L16.4749 12.0051Z",
        fill: "currentColor"
      }
    )
  );
}
function ChevronUpThin() {
  return /* @__PURE__ */ React11.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Chevron Up",
      role: "img"
    },
    /* @__PURE__ */ React11.createElement("title", null, "Chevron Up"),
    /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M12.0051 7.52511L3.76231 15.7627L3 14.9999L12.0056 6L21 15.0001L20.2372 15.7624L12.0051 7.52511Z",
        fill: "currentColor"
      }
    )
  );
}
function ChevronDownThin() {
  return /* @__PURE__ */ React11.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Chevron Down"
    },
    /* @__PURE__ */ React11.createElement("title", null, "Chevron Down"),
    /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M11.9949 16.4749L20.2377 8.23732L21 9.00012L11.9944 18L3 8.99988L3.7628 8.23757L11.9949 16.4749Z",
        fill: "currentColor"
      }
    )
  );
}

// src/CreditCard.tsx
import * as React12 from "react";
var TITLE9 = "Credit Card";
function CreditCard() {
  return /* @__PURE__ */ React12.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      "aria-label": TITLE9,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React12.createElement("title", null, TITLE9),
    /* @__PURE__ */ React12.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5 6C3.67157 6 3 6.67157 3 7.5V16.5C3 17.3284 3.67157 18 4.5 18H19.5C20.3284 18 21 17.3284 21 16.5V7.5C21 6.67157 20.3284 6 19.5 6H4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H19.5C19.7761 7 20 7.22386 20 7.5V8H4V7.5ZM4 11V16.5C4 16.7761 4.22386 17 4.5 17H19.5C19.7761 17 20 16.7761 20 16.5V11H4Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Edit.tsx
import * as React13 from "react";
function Edit({ title = "Edit" }) {
  return /* @__PURE__ */ React13.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": title,
      role: "img"
    },
    /* @__PURE__ */ React13.createElement("title", null, title),
    /* @__PURE__ */ React13.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 7.68747L16.3125 4L5.22972 15.0828L8.9172 18.7702L20 7.68747ZM4.68095 15.6316L3.99997 20.0001L8.36843 19.3191L4.68095 15.6316Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Email.tsx
import * as React14 from "react";
var TITLE10 = "Email";
function Email() {
  return /* @__PURE__ */ React14.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-label": TITLE10,
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React14.createElement("title", null, TITLE10),
    /* @__PURE__ */ React14.createElement(
      "path",
      {
        d: "M2 17.2612V6.73878L7.975 12.1755L2 17.2612ZM22 19H2L8.99167 13.0571L12 15.8082L15.0083 13.0571L22 19ZM12 14.0122L2.05833 5H21.9417L12 14.0122ZM22 6.73878V17.2612L16.025 12.1755L22 6.73878Z",
        fill: "currentColor"
      }
    )
  );
}
function EmailSimple() {
  return /* @__PURE__ */ React14.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE10,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React14.createElement("title", null, TITLE10),
    /* @__PURE__ */ React14.createElement(
      "path",
      {
        d: "M2 20V4h20v16H2Zm10-7 8-5V6l-8 5-8-5v2l8 5Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Exclamation.tsx
import * as React15 from "react";
var TITLE11 = "Exclamation";
function ExclamationStroke({ className }) {
  return /* @__PURE__ */ React15.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      "aria-label": TITLE11,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React15.createElement("title", null, TITLE11),
    /* @__PURE__ */ React15.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10.6667 8.66667V6H13.3333V8.66667L12.6625 14H11.3375L10.6667 8.66667ZM10.6667 18V15.3333H13.3333V18H10.6667Z",
        fill: "currentColor"
      }
    )
  );
}
function ExclamationFilled({ className }) {
  return /* @__PURE__ */ React15.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE11,
      role: "img"
    },
    /* @__PURE__ */ React15.createElement("title", null, TITLE11),
    /* @__PURE__ */ React15.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.6667 8.66667V6H13.3333V8.66667L12.6625 14H11.3375L10.6667 8.66667ZM10.6667 18V15.3333H13.3333V18H10.6667Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Exit.tsx
import * as React16 from "react";
var TITLE12 = "Exit";
function ExitThin({ title = TITLE12, className }) {
  return /* @__PURE__ */ React16.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": title
    },
    /* @__PURE__ */ React16.createElement("title", null, title),
    /* @__PURE__ */ React16.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.45 3.45L20.55 2.55L12 11.1L3.45 2.55L2.55 3.45L11.1 12L2.55 20.55L3.45 21.45L12 12.9L20.55 21.45L21.45 20.55L12.9 12L21.45 3.45Z",
        fill: "currentColor"
      }
    )
  );
}
function Exit({ title = TITLE12, className }) {
  return /* @__PURE__ */ React16.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": title
    },
    /* @__PURE__ */ React16.createElement("title", null, title),
    /* @__PURE__ */ React16.createElement(
      "path",
      {
        d: "M12 10.1651L3.83495 2L2 3.83495L10.1651 12L2 20.1651L3.83495 22L12 13.8349L20.1651 22L22 20.1651L13.8349 12L22 3.83495L20.1651 2L12 10.1651Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Expand.tsx
import React17 from "react";
var Title = "Expand";
function Expand() {
  return /* @__PURE__ */ React17.createElement(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React17.createElement("title", null, Title),
    /* @__PURE__ */ React17.createElement("g", { fill: "currentColor", fillRule: "nonzero" }, /* @__PURE__ */ React17.createElement("path", { d: "M2.207 14.24H6.6v1H.5v-6.1h1v4.392l5.086-5.086.707.707-5.086 5.087zM13.532 1.5H9.14v-1h6.1v6.1h-1V2.207L9.153 7.293l-.707-.707L13.532 1.5z" }))
  );
}

// src/Facebook.tsx
import * as React18 from "react";
var TITLE13 = "Facebook";
function Facebook({ className }) {
  return /* @__PURE__ */ React18.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE13,
      className
    },
    /* @__PURE__ */ React18.createElement("title", null, TITLE13),
    /* @__PURE__ */ React18.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 12.0611C22 6.50451 17.5229 2 12 2C6.47715 2 2 6.50451 2 12.0611C2 17.0829 5.65686 21.2452 10.4375 22V14.9694H7.89844V12.0611H10.4375V9.84452C10.4375 7.32296 11.9304 5.93012 14.2146 5.93012C15.3087 5.93012 16.4531 6.12663 16.4531 6.12663V8.60261H15.1921C13.9499 8.60261 13.5625 9.37816 13.5625 10.1738V12.0611H16.3359L15.8926 14.9694H13.5625V22C18.3431 21.2452 22 17.0829 22 12.0611Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Gift.tsx
import * as React19 from "react";
var TITLE14 = "Gift";
function Gift() {
  return /* @__PURE__ */ React19.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE14
    },
    /* @__PURE__ */ React19.createElement("title", null, TITLE14),
    /* @__PURE__ */ React19.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5179 6.25172C11.1965 6.18625 11.4014 5.95443 11.4449 5.86581C11.4884 5.77719 11.5424 5.48119 11.1513 4.96062C10.7815 4.46843 10.1189 3.94521 9.22856 3.56643C8.33825 3.18765 7.47969 3.06367 6.83808 3.12558C6.15948 3.19105 5.95458 3.42286 5.9111 3.51149C5.86762 3.60011 5.81358 3.8961 6.20467 4.41667C6.57444 4.90886 7.23712 5.43209 8.12743 5.81087C9.01773 6.18965 9.87629 6.31362 10.5179 6.25172ZM12.2108 6.49999C12.2173 6.49181 12.2238 6.48357 12.2301 6.47526C12.2364 6.48357 12.2429 6.49181 12.2494 6.49999H12.2108ZM7.23975 6.49999C5.47818 5.60218 4.48497 4.15127 4.99092 3.12C5.53824 2.00438 7.63269 1.80231 9.66901 2.66865C10.8824 3.18488 11.8013 3.96397 12.2301 4.74539C12.6589 3.96397 13.5778 3.18488 14.7912 2.66865C16.8275 1.80231 18.922 2.00438 19.4693 3.12C19.9752 4.15127 18.982 5.60218 17.2205 6.49999H22V11.5H20V21.5H3.9V11.5H2V6.49999H7.23975ZM13.9423 6.25172C13.2637 6.18625 13.0588 5.95443 13.0153 5.86581C12.9718 5.77719 12.9178 5.48119 13.3089 4.96062C13.6787 4.46843 14.3413 3.94521 15.2316 3.56643C16.122 3.18765 16.9805 3.06367 17.6221 3.12558C18.3007 3.19105 18.5056 3.42286 18.5491 3.51149C18.5926 3.60011 18.6466 3.8961 18.2555 4.41667C17.8858 4.90886 17.2231 5.43209 16.3328 5.81087C15.4425 6.18965 14.5839 6.31362 13.9423 6.25172ZM4.9 20.5V11.5H9.07102V20.5H4.9ZM9.07102 7.49999V10.5H3V7.49999H9.07102ZM10.071 20.5V7.49999H13.929V20.5H10.071ZM14.929 10.5V7.49999H21V10.5H14.929ZM14.929 20.5V11.5H19V20.5H14.929Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Google.tsx
import * as React20 from "react";
var TITLE15 = "Google";
function Google({ isMultiColor }) {
  return /* @__PURE__ */ React20.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-label": TITLE15,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React20.createElement("title", null, TITLE15),
    /* @__PURE__ */ React20.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1 11.2273C20.1 10.5182 20.0364 9.83637 19.9182 9.18182H10.5V13.05H15.8818C15.65 14.3 14.9455 15.3591 13.8864 16.0682V18.5773H17.1182C19.0091 16.8364 20.1 14.2727 20.1 11.2273Z",
        fill: isMultiColor ? "#4285F4" : "currentColor"
      }
    ),
    /* @__PURE__ */ React20.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4998 20.9999C13.1998 20.9999 15.4635 20.1044 17.118 18.5771L13.8862 16.068C12.9907 16.668 11.8453 17.0226 10.4998 17.0226C7.89529 17.0226 5.69075 15.2635 4.90439 12.8999H1.56348V15.4908C3.20893 18.7589 6.59075 20.9999 10.4998 20.9999Z",
        fill: isMultiColor ? "#34A853" : "currentColor"
      }
    ),
    /* @__PURE__ */ React20.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.90455 12.9C4.70455 12.3 4.59091 11.6591 4.59091 11C4.59091 10.341 4.70455 9.70005 4.90455 9.10005V6.50914H1.56364C0.886364 7.85914 0.5 9.38641 0.5 11C0.5 12.6137 0.886364 14.141 1.56364 15.491L4.90455 12.9Z",
        fill: isMultiColor ? "#FBBC05" : "currentColor"
      }
    ),
    /* @__PURE__ */ React20.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4998 4.97727C11.968 4.97727 13.2862 5.48182 14.3226 6.47273L17.1908 3.60455C15.4589 1.99091 13.1953 1 10.4998 1C6.59075 1 3.20893 3.24091 1.56348 6.50909L4.90439 9.1C5.69075 6.73636 7.8953 4.97727 10.4998 4.97727Z",
        fill: isMultiColor ? "#EA4335" : "currentColor"
      }
    )
  );
}

// src/GooglePodcasts.tsx
import * as React21 from "react";
var TITLE16 = "Google Podcasts";
function GooglePodcasts() {
  return /* @__PURE__ */ React21.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-label": TITLE16,
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React21.createElement("title", null, TITLE16),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C11.6685 2 11.3505 2.13167 11.1161 2.36609C10.8817 2.60051 10.75 2.91848 10.75 3.25V4.60999C10.75 4.94151 10.8817 5.25948 11.1161 5.4939C11.3505 5.72832 11.6685 5.85999 12 5.85999C12.3315 5.85999 12.6495 5.72832 12.8839 5.4939C13.1183 5.25948 13.25 4.94151 13.25 4.60999V3.25C13.25 2.91848 13.1183 2.60051 12.8839 2.36609C12.6495 2.13167 12.3315 2 12 2Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.56982 6C7.2383 6 6.92046 6.13167 6.68604 6.36609C6.45161 6.60051 6.31982 6.91848 6.31982 7.25V11.71C6.31982 12.0415 6.45161 12.3595 6.68604 12.5939C6.92046 12.8283 7.2383 12.96 7.56982 12.96C7.90134 12.96 8.21932 12.8283 8.45374 12.5939C8.68816 12.3595 8.81982 12.0415 8.81982 11.71V7.25C8.81982 6.91848 8.68816 6.60051 8.45374 6.36609C8.21932 6.13167 7.90134 6 7.56982 6Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 10.0699C2.91848 10.0699 2.60051 10.2017 2.36609 10.4362C2.13167 10.6706 2 10.9884 2 11.3199V12.6801C2 13.0116 2.13167 13.3294 2.36609 13.5638C2.60051 13.7983 2.91848 13.9301 3.25 13.9301C3.58152 13.9301 3.89949 13.7983 4.13391 13.5638C4.36833 13.3294 4.5 13.0116 4.5 12.6801V11.3199C4.5 10.9884 4.36833 10.6706 4.13391 10.4362C3.89949 10.2017 3.58152 10.0699 3.25 10.0699Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 11.3199C22 10.9884 21.8683 10.6706 21.6339 10.4362C21.3995 10.2017 21.0815 10.0699 20.75 10.0699C20.4185 10.0699 20.1005 10.2017 19.8661 10.4362C19.6317 10.6706 19.5 10.9884 19.5 11.3199V12.6899C19.5 13.0215 19.6317 13.3394 19.8661 13.5739C20.1005 13.8083 20.4185 13.9399 20.75 13.9399C21.0815 13.9399 21.3995 13.8083 21.6339 13.5739C21.8683 13.3394 22 13.0215 22 12.6899V11.3199Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.68604 14.5261C6.92046 14.2917 7.2383 14.16 7.56982 14.16C7.90134 14.16 8.21932 14.2917 8.45374 14.5261C8.68816 14.7605 8.81982 15.0785 8.81982 15.41V16.77C8.81982 17.1015 8.68816 17.4195 8.45374 17.6539C8.21932 17.8884 7.90134 18.02 7.56982 18.02C7.2383 18.02 6.92046 17.8884 6.68604 17.6539C6.45161 17.4195 6.31982 17.1015 6.31982 16.77V15.41C6.31982 15.0785 6.45161 14.7605 6.68604 14.5261Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5463 6.36609C15.7807 6.13167 16.0987 6 16.4302 6C16.7617 6 17.0795 6.13167 17.314 6.36609C17.5484 6.60051 17.6802 6.91848 17.6802 7.25V8.60999C17.6802 8.94151 17.5484 9.25948 17.314 9.4939C17.0795 9.72832 16.7617 9.85999 16.4302 9.85999C16.0987 9.85999 15.7807 9.72832 15.5463 9.4939C15.3118 9.25948 15.1802 8.94151 15.1802 8.60999V7.25C15.1802 6.91848 15.3118 6.60051 15.5463 6.36609Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.1161 18.5061C11.3505 18.2717 11.6685 18.14 12 18.14C12.3315 18.14 12.6495 18.2717 12.8839 18.5061C13.1183 18.7405 13.25 19.0585 13.25 19.39V20.75C13.25 21.0815 13.1183 21.3995 12.8839 21.6339C12.6495 21.8683 12.3315 22 12 22C11.6685 22 11.3505 21.8683 11.1161 21.6339C10.8817 21.3995 10.75 21.0815 10.75 20.75V19.39C10.75 19.0585 10.8817 18.7405 11.1161 18.5061Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.4302 11.09C16.0987 11.09 15.7807 11.2218 15.5463 11.4562C15.3118 11.6906 15.1802 12.0084 15.1802 12.34V16.77C15.1802 17.1015 15.3118 17.4195 15.5463 17.6539C15.7807 17.8884 16.0987 18.02 16.4302 18.02C16.7617 18.02 17.0795 17.8884 17.314 17.6539C17.5484 17.4195 17.6802 17.1015 17.6802 16.77V12.34C17.6802 12.0084 17.5484 11.6906 17.314 11.4562C17.0795 11.2218 16.7617 11.09 16.4302 11.09Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.1161 7.47607C11.3505 7.24165 11.6685 7.10999 12 7.10999C12.3315 7.10999 12.6495 7.24165 12.8839 7.47607C13.1183 7.71049 13.25 8.02846 13.25 8.35999V15.64C13.25 15.9715 13.1183 16.2895 12.8839 16.5239C12.6495 16.7583 12.3315 16.89 12 16.89C11.6685 16.89 11.3505 16.7583 11.1161 16.5239C10.8817 16.2895 10.75 15.9715 10.75 15.64V8.35999C10.75 8.02846 10.8817 7.71049 11.1161 7.47607Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Hamburger.tsx
import * as React22 from "react";
var TITLE17 = "Menu";
function Hamburger({ className }) {
  return /* @__PURE__ */ React22.createElement(
    "svg",
    {
      className,
      width: "100%",
      height: "100%",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE17,
      role: "img"
    },
    /* @__PURE__ */ React22.createElement("title", null, TITLE17),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 6H19V8H5V6ZM5 11H19V13H5V11ZM19 16H5V18H19V16Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Headphones.tsx
import * as React23 from "react";
var TITLE18 = "Headphones";
function Headphones({ className }) {
  return /* @__PURE__ */ React23.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE18,
      role: "img"
    },
    /* @__PURE__ */ React23.createElement(
      "path",
      {
        d: "M12 3C7.03 3 3 7.03 3 12V19C3 20.1 3.9 21 5 21H9V13H5V12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12V13H15V21H19C20.1 21 21 20.1 21 19V12C21 7.03 16.97 3 12 3Z",
        fill: "currentColor"
      }
    )
  );
}

// src/IHeartRadio.tsx
import * as React24 from "react";
var TITLE19 = "iHeartRadio";
function IHeartRadio() {
  return /* @__PURE__ */ React24.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE19,
      role: "img"
    },
    /* @__PURE__ */ React24.createElement("title", null, TITLE19),
    /* @__PURE__ */ React24.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.56 4.99999C15.6568 5.00647 14.769 5.2341 13.9741 5.66293C13.1792 6.09176 12.5014 6.70876 12 7.46002C11.5015 6.70831 10.8257 6.09076 10.0322 5.66177C9.23877 5.23278 8.35198 5.0055 7.45 4.99999C6.73476 4.99868 6.02629 5.13842 5.36513 5.41122C4.70396 5.68402 4.10309 6.08453 3.59688 6.58981C3.09067 7.09509 2.68907 7.69523 2.41505 8.35589C2.14104 9.01655 2 9.72476 2 10.44C2 12.35 3.21001 13.73 4.48001 15L9.42 19.67C9.47652 19.7254 9.5482 19.7628 9.62598 19.7775C9.70376 19.7921 9.78415 19.7834 9.85695 19.7523C9.92975 19.7213 9.99171 19.6693 10.035 19.6031C10.0782 19.5368 10.1009 19.4591 10.1 19.38V15.74C10.081 15.4782 10.1162 15.2154 10.2033 14.9678C10.2905 14.7202 10.4277 14.4933 10.6064 14.3011C10.7852 14.1089 11.0017 13.9556 11.2423 13.8508C11.4829 13.746 11.7425 13.6919 12.005 13.6919C12.2675 13.6919 12.5271 13.746 12.7677 13.8508C13.0084 13.9556 13.2248 14.1089 13.4035 14.3011C13.5823 14.4933 13.7195 14.7202 13.8067 14.9678C13.8938 15.2154 13.929 15.4782 13.91 15.74V19.39C13.9091 19.4692 13.9318 19.5468 13.975 19.613C14.0183 19.6793 14.0803 19.7313 14.1531 19.7623C14.2259 19.7934 14.3062 19.8021 14.384 19.7875C14.4618 19.7728 14.5335 19.7354 14.59 19.68L19.53 15.01C20.8 13.74 22 12.36 22 10.45C22.0026 9.7344 21.8638 9.02534 21.5915 8.36358C21.3191 7.70182 20.9187 7.1004 20.4131 6.59393C19.9076 6.08745 19.3069 5.68592 18.6457 5.41238C17.9844 5.13883 17.2756 4.99867 16.56 4.99999ZM7.06 14.64C7.02544 14.6806 6.98253 14.7132 6.9342 14.7356C6.88588 14.7581 6.83328 14.7698 6.78 14.77C6.68855 14.7711 6.59979 14.7391 6.53 14.68C5.82363 14.1532 5.23912 13.4803 4.81633 12.7072C4.39354 11.9341 4.14239 11.079 4.08 10.2C4.09772 9.51658 4.27516 8.84681 4.59814 8.24426C4.92113 7.64171 5.38067 7.12311 5.94 6.73001C6.02506 6.67766 6.1273 6.66092 6.22461 6.68337C6.32192 6.70583 6.40649 6.76568 6.46001 6.85C6.50984 6.93569 6.52516 7.03716 6.50287 7.13375C6.48058 7.23034 6.42234 7.31483 6.34 7.37002C5.88778 7.694 5.51632 8.11784 5.25444 8.60864C4.99256 9.09944 4.84733 9.64398 4.83 10.2C4.89695 10.9709 5.12788 11.7185 5.50731 12.3928C5.88673 13.0672 6.40589 13.6526 7.03 14.11C7.10318 14.177 7.14729 14.2699 7.15289 14.3689C7.1585 14.4679 7.12516 14.5652 7.06 14.64ZM9.49001 13.24C9.45787 13.2998 9.41031 13.3498 9.35228 13.385C9.29425 13.4202 9.22786 13.4392 9.16 13.44C9.09376 13.4375 9.02888 13.4205 8.97 13.39C8.43282 13.0875 7.98127 12.6536 7.65768 12.1288C7.3341 11.6041 7.1491 11.0058 7.12001 10.39C7.11705 9.83365 7.26886 9.28744 7.55847 8.8124C7.84809 8.33736 8.2641 7.95222 8.76001 7.70001C8.84775 7.65336 8.95026 7.64295 9.04559 7.67098C9.14092 7.69902 9.22149 7.76328 9.27 7.85C9.3133 7.9394 9.32084 8.04197 9.29111 8.13674C9.26137 8.23152 9.1966 8.31136 9.11 8.36001C8.74355 8.55132 8.43573 8.83824 8.21918 9.19036C8.00262 9.54248 7.88542 9.94666 7.88 10.36C7.89948 10.8471 8.04402 11.3211 8.29973 11.7361C8.55543 12.1512 8.91368 12.4935 9.34 12.73C9.42672 12.7785 9.49099 12.8591 9.51903 12.9544C9.54707 13.0497 9.53665 13.1523 9.49001 13.24ZM12 12.24C11.6756 12.24 11.3586 12.1438 11.0889 11.9636C10.8192 11.7834 10.609 11.5273 10.4848 11.2276C10.3607 10.928 10.3282 10.5982 10.3915 10.2801C10.4548 9.96192 10.611 9.66972 10.8403 9.44036C11.0697 9.211 11.3619 9.05479 11.6801 8.99151C11.9982 8.92823 12.3279 8.9607 12.6276 9.08483C12.9273 9.20896 13.1834 9.41917 13.3636 9.68887C13.5438 9.95856 13.64 10.2756 13.64 10.6C13.6467 10.8191 13.6092 11.0372 13.5297 11.2415C13.4502 11.4457 13.3303 11.6318 13.1772 11.7887C13.0241 11.9455 12.8409 12.0698 12.6386 12.1543C12.4364 12.2387 12.2192 12.2815 12 12.28V12.24ZM15 13.35C14.9411 13.3805 14.8762 13.3975 14.81 13.4C14.7421 13.3992 14.6758 13.3802 14.6177 13.345C14.5597 13.3099 14.5121 13.2598 14.48 13.2C14.4556 13.1569 14.44 13.1092 14.4344 13.06C14.4287 13.0107 14.433 12.9608 14.447 12.9132C14.461 12.8657 14.4844 12.8214 14.5158 12.783C14.5473 12.7447 14.5861 12.713 14.63 12.69C15.0563 12.4535 15.4146 12.1112 15.6703 11.6962C15.926 11.2811 16.0705 10.8071 16.09 10.32C16.0846 9.90666 15.9674 9.5025 15.7508 9.15038C15.5343 8.79827 15.2264 8.51131 14.86 8.32C14.7734 8.27135 14.7086 8.19151 14.6789 8.09673C14.6492 8.00196 14.6567 7.89942 14.7 7.81002C14.7485 7.7233 14.8291 7.65901 14.9244 7.63098C15.0197 7.60294 15.1223 7.61335 15.21 7.66C15.7233 7.90676 16.1557 8.29452 16.4567 8.77795C16.7578 9.26138 16.915 9.82053 16.91 10.39C16.8789 11.0077 16.6908 11.6074 16.3636 12.1323C16.0365 12.6572 15.5809 13.09 15.04 13.39L15 13.35ZM19.89 10.16C19.8276 11.039 19.5765 11.8942 19.1537 12.6673C18.7309 13.4404 18.1464 14.1132 17.44 14.64C17.3702 14.6991 17.2815 14.7311 17.19 14.73C17.1365 14.7312 17.0834 14.7201 17.0349 14.6975C16.9864 14.675 16.9436 14.6416 16.91 14.6C16.841 14.5291 16.8024 14.434 16.8024 14.335C16.8024 14.236 16.841 14.1409 16.91 14.07C17.5341 13.6126 18.0533 13.0272 18.4327 12.3528C18.8121 11.6785 19.043 10.9309 19.11 10.16C19.0927 9.60397 18.9474 9.05943 18.6856 8.56863C18.4237 8.07783 18.0522 7.65399 17.6 7.33001C17.5515 7.30712 17.5083 7.2742 17.4734 7.23342C17.4385 7.19265 17.4126 7.14494 17.3975 7.09344C17.3824 7.04194 17.3783 6.9878 17.3856 6.93463C17.3929 6.88145 17.4114 6.83042 17.4398 6.78491C17.4683 6.73939 17.5061 6.70042 17.5507 6.67056C17.5953 6.64069 17.6457 6.62062 17.6986 6.61166C17.7515 6.60269 17.8057 6.60502 17.8577 6.61852C17.9096 6.63203 17.9581 6.65639 18 6.69C18.5726 7.08064 19.0443 7.60162 19.3764 8.21008C19.7084 8.81853 19.8913 9.49709 19.91 10.19L19.89 10.16Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Info.tsx
import * as React25 from "react";
var TITLE20 = "Info";
function InfoStroke() {
  return /* @__PURE__ */ React25.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE20,
      role: "img"
    },
    /* @__PURE__ */ React25.createElement("title", null, TITLE20),
    /* @__PURE__ */ React25.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11 8V6H13V8H11ZM11 18V10H13V18H11Z",
        fill: "currentColor"
      }
    )
  );
}
function InfoFilled() {
  return /* @__PURE__ */ React25.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-label": TITLE20,
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React25.createElement("title", null, TITLE20),
    /* @__PURE__ */ React25.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 8V6H13V8H11ZM11 18V10H13V18H11Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Instagram.tsx
import * as React26 from "react";
var TITLE21 = "Instagram";
function Instagram({ className }) {
  return /* @__PURE__ */ React26.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE21,
      className
    },
    /* @__PURE__ */ React26.createElement("title", null, TITLE21),
    /* @__PURE__ */ React26.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1388 16.0404C20.0943 17.0154 19.9312 17.5452 19.7958 17.8971C19.614 18.3636 19.397 18.6972 19.0451 19.0471C18.6972 19.397 18.3636 19.6135 17.8971 19.7933C17.5452 19.9307 17.0134 20.0943 16.0384 20.1408C14.9843 20.1872 14.6719 20.1971 11.9988 20.1971C9.32809 20.1971 9.01325 20.1872 7.95911 20.1408C6.98407 20.0943 6.45478 19.9307 6.10288 19.7933C5.63389 19.6135 5.30279 19.397 4.95289 19.0471C4.60051 18.6972 4.38356 18.3636 4.20417 17.8971C4.06873 17.5452 3.9032 17.0154 3.86116 16.0404C3.80979 14.9862 3.80038 14.6689 3.80038 12.0012C3.80038 9.32809 3.80979 9.01325 3.86116 7.95911C3.9032 6.98407 4.06873 6.45478 4.20417 6.09991C4.38356 5.63389 4.60051 5.30227 4.95289 4.95237C5.30279 4.60299 5.63389 4.38601 6.10288 4.20417C6.45478 4.06628 6.98407 3.90516 7.95911 3.85872C9.01325 3.81224 9.32809 3.80038 11.9988 3.80038C14.6719 3.80038 14.9843 3.81224 16.0384 3.85872C17.0134 3.90516 17.5452 4.06628 17.8971 4.20417C18.3636 4.38601 18.6972 4.60299 19.0451 4.95237C19.397 5.30227 19.614 5.63389 19.7958 6.09991C19.9312 6.45478 20.0943 6.98407 20.1388 7.95911C20.1877 9.01325 20.1996 9.32809 20.1996 12.0012C20.1996 14.6689 20.1877 14.9862 20.1388 16.0404ZM21.9392 7.87709C21.8903 6.81157 21.7222 6.0836 21.4727 5.44956C21.2187 4.79176 20.8781 4.2343 20.3207 3.67684C19.7657 3.12186 19.2082 2.78134 18.5504 2.52436C17.9139 2.27725 17.1884 2.10723 16.1224 2.06079C15.0564 2.00938 14.7159 2 11.9988 2C9.28409 2 8.94112 2.00938 7.87512 2.06079C6.81157 2.10723 6.08657 2.27725 5.44708 2.52436C4.79176 2.78134 4.2343 3.12186 3.67932 3.67684C3.12186 4.2343 2.78134 4.79176 2.52485 5.44956C2.27773 6.0836 2.10971 6.81157 2.0583 7.87709C2.01186 8.94309 2 9.28409 2 12.0012C2 14.7159 2.01186 15.0564 2.0583 16.1224C2.10971 17.1859 2.27773 17.9134 2.52485 18.5504C2.78134 19.2058 3.12186 19.7657 3.67932 20.3207C4.2343 20.8757 4.79176 21.2187 5.44708 21.4752C6.08657 21.7222 6.81157 21.8903 7.87512 21.9392C8.94112 21.9881 9.28409 22 11.9988 22C14.7159 22 15.0564 21.9881 16.1224 21.9392C17.1884 21.8903 17.9139 21.7222 18.5504 21.4752C19.2082 21.2187 19.7657 20.8757 20.3207 20.3207C20.8781 19.7657 21.2187 19.2058 21.4727 18.5504C21.7222 17.9134 21.8903 17.1859 21.9392 16.1224C21.9881 15.0564 22 14.7159 22 12.0012C22 9.28409 21.9881 8.94309 21.9392 7.87709ZM18.5385 6.66234C18.5385 5.99764 17.9998 5.46094 17.3376 5.46094C16.6754 5.46094 16.1362 5.99764 16.1362 6.66234C16.1362 7.32458 16.6754 7.86129 17.3376 7.86129C17.9998 7.86129 18.5385 7.32458 18.5385 6.66234ZM8.66588 12.0012C8.66588 13.8411 10.1589 15.3317 11.9988 15.3317C13.8392 15.3317 15.3342 13.8411 15.3342 12.0012C15.3342 10.1583 13.8392 8.66583 11.9988 8.66583C10.1589 8.66583 8.66588 10.1583 8.66588 12.0012ZM6.8655 12.0012C6.8655 9.16495 9.16255 6.86297 11.9988 6.86297C14.835 6.86297 17.1346 9.16495 17.1346 12.0012C17.1346 14.835 14.835 17.1345 11.9988 17.1345C9.16255 17.1345 6.8655 14.835 6.8655 12.0012Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Key.tsx
import * as React27 from "react";
var TITLE22 = "Key";
function Key() {
  return /* @__PURE__ */ React27.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE22
    },
    /* @__PURE__ */ React27.createElement(
      "path",
      {
        d: "M12.65 10C11.83 7.67 9.61 6 7 6C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18C9.61 18 11.83 16.33 12.65 14H17V18H21V14H23V10H12.65ZM7 14C5.9 14 5 13.1 5 12C5 10.9 5.9 10 7 10C8.1 10 9 10.9 9 12C9 13.1 8.1 14 7 14Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Lightbulb.tsx
import * as React28 from "react";
function Lightbulb({
  className,
  title = "Lightbulb"
}) {
  return /* @__PURE__ */ React28.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": title,
      role: "img"
    },
    /* @__PURE__ */ React28.createElement("title", null, title),
    /* @__PURE__ */ React28.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5 9.5C4.5 5.36 7.86 2 12 2C16.14 2 19.5 5.36 19.5 9.5C19.5 13.32 16.84 15.36 15.73 16H8.27C7.16 15.36 4.5 13.32 4.5 9.5ZM16 19V17H8V19H16ZM12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Line.tsx
import * as React29 from "react";
var TITLE23 = "Line";
function Line({ className }) {
  return /* @__PURE__ */ React29.createElement(
    "svg",
    {
      width: "89",
      height: "85",
      viewBox: "0 0 89 85",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      "aria-label": TITLE23
    },
    /* @__PURE__ */ React29.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M88.54 35.9255C88.54 16.1163 68.6809 0 44.27 0C19.8632 0 0 16.1163 0 35.9255C0 53.685 15.7511 68.5564 37.0251 71.3697C38.465 71.6809 40.4276 72.3199 40.9256 73.5523C41.3737 74.6727 41.216 76.4237 41.0708 77.5565C41.0708 77.5565 40.5521 80.681 40.4401 81.3449C40.2451 82.4652 39.5521 85.7225 44.2741 83.7308C49.0003 81.7391 69.7681 68.7183 79.0544 58.0294C85.4653 50.9962 88.54 43.855 88.54 35.9255ZM73.8135 47.3654H61.3943H61.3777C60.9088 47.3654 60.5312 46.9878 60.5312 46.5189V46.5065V27.2201V27.2035C60.5312 26.7346 60.9088 26.357 61.3777 26.357H61.3943H73.8135C74.2782 26.357 74.66 26.7387 74.66 27.2035V30.3446C74.66 30.8135 74.2824 31.191 73.8135 31.191H65.3612V34.4525H73.8135C74.2782 34.4525 74.66 34.8342 74.66 35.299V38.4401C74.66 38.9089 74.2824 39.2865 73.8135 39.2865H65.3612V42.548H73.8135C74.2782 42.548 74.66 42.9297 74.66 43.3944V46.5355C74.66 46.9878 74.2824 47.3654 73.8135 47.3654ZM27.8098 47.3654C28.2746 47.3654 28.6563 46.9878 28.6563 46.5189V43.3778C28.6563 42.9131 28.2746 42.5314 27.8098 42.5314H19.3575V27.1952C19.3575 26.7304 18.9757 26.3487 18.511 26.3487H15.3699C14.901 26.3487 14.5234 26.7263 14.5234 27.1952V46.5023V46.5148C14.5234 46.9837 14.901 47.3613 15.3699 47.3613H15.3865H27.8098V47.3654ZM35.2923 26.3528H32.1512C31.6864 26.3528 31.3047 26.7304 31.3047 27.1993V46.5189C31.3047 46.9837 31.6823 47.3654 32.1512 47.3654H35.2923C35.7611 47.3654 36.1387 46.9878 36.1387 46.5189V27.1993C36.1387 26.7346 35.7611 26.3528 35.2923 26.3528ZM56.6626 26.3528H53.5215C53.0526 26.3528 52.675 26.7304 52.675 27.1993V38.6724L43.8368 26.7346C43.816 26.7055 43.7911 26.6765 43.7704 26.6475L43.7662 26.6433C43.7496 26.6267 43.733 26.606 43.7164 26.5894C43.7123 26.5852 43.704 26.5811 43.6998 26.5769C43.6832 26.5645 43.6708 26.552 43.6542 26.5396C43.6459 26.5354 43.6376 26.5271 43.6293 26.523C43.6169 26.5105 43.6003 26.5022 43.5837 26.4939C43.5754 26.4898 43.5671 26.4815 43.5588 26.4773C43.5422 26.469 43.5297 26.4607 43.5131 26.4524C43.5048 26.4483 43.4965 26.4441 43.4882 26.44C43.4716 26.4317 43.455 26.4234 43.4384 26.4192C43.4301 26.4151 43.4218 26.4109 43.4094 26.4109C43.3928 26.4068 43.3762 26.3985 43.3596 26.3943C43.3513 26.3902 43.3388 26.3902 43.3305 26.386C43.314 26.3819 43.2974 26.3777 43.2808 26.3736C43.2683 26.3694 43.2559 26.3694 43.2434 26.3694C43.2268 26.3653 43.2144 26.3653 43.1978 26.3653C43.1812 26.3653 43.1687 26.3653 43.1521 26.3611C43.1438 26.3611 43.1314 26.3611 43.1231 26.3611H40.0027C39.538 26.3611 39.1562 26.7387 39.1562 27.2076V46.5272C39.1562 46.992 39.5338 47.3737 40.0027 47.3737H43.1438C43.6127 47.3737 43.9903 46.9961 43.9903 46.5272V35.0541L52.841 47.0086C52.9032 47.0957 52.9779 47.1663 53.0609 47.2202C53.065 47.2243 53.0692 47.2243 53.0692 47.2285C53.0858 47.2409 53.1024 47.2492 53.1231 47.2617C53.1314 47.2658 53.1397 47.27 53.148 47.2741C53.1605 47.2824 53.1771 47.2866 53.1895 47.2949C53.202 47.3032 53.2186 47.3073 53.231 47.3115C53.2393 47.3156 53.2476 47.3198 53.2559 47.3198C53.2767 47.3281 53.2933 47.3322 53.314 47.3364C53.3182 47.3364 53.3223 47.3405 53.3265 47.3405C53.397 47.3571 53.4717 47.3696 53.5464 47.3696H56.6667C57.1315 47.3696 57.5132 46.992 57.5132 46.5231V27.2035C57.5091 26.7346 57.1315 26.3528 56.6626 26.3528Z",
        fill: "currentColor"
      }
    )
  );
}

// src/LineChevron.tsx
import * as React30 from "react";
var TITLE24 = "Chevron";
function LineChevronLeft() {
  return /* @__PURE__ */ React30.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": "Chevron Line Left",
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React30.createElement("title", null, TITLE24),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 3H5V21H7V3ZM19.46 19.5387L11.9216 11.9954L19.4595 4.46225L17.9982 3L8.99798 11.9945L17.9977 21L19.46 19.5387Z",
        fill: "currentColor"
      }
    )
  );
}
function LineChevronRight() {
  return /* @__PURE__ */ React30.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": "Chevron Line Right",
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React30.createElement("title", null, TITLE24),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 21H19L19 3H17L17 21ZM4.54 4.46132L12.0784 12.0046L4.54047 19.5377L6.00179 21L15.002 12.0055L6.00225 3L4.54 4.46132Z",
        fill: "currentColor"
      }
    )
  );
}
function LineChevronUp() {
  return /* @__PURE__ */ React30.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE24,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React30.createElement("title", null, TITLE24),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 7V5L3 5V7L21 7ZM4.46132 19.46L12.0046 11.9216L19.5377 19.4595L21 17.9982L12.0055 8.99798L3 17.9977L4.46132 19.46Z",
        fill: "currentColor"
      }
    )
  );
}
function LineChevronDown() {
  return /* @__PURE__ */ React30.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE24,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React30.createElement("title", null, TITLE24),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 17V19H21V17H3ZM19.5387 4.54L11.9954 12.0784L4.46225 4.54047L3 6.00179L11.9945 15.002L21 6.00225L19.5387 4.54Z",
        fill: "currentColor"
      }
    )
  );
}
function LineChevronLeftThin() {
  return /* @__PURE__ */ React30.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE24,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React30.createElement("title", null, TITLE24),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 3H6V21H7V3ZM18.7627 3.76231L10.5251 12.0051L18.7624 20.2372L18.0001 21L9 12.0056L17.9999 3L18.7627 3.76231Z",
        fill: "currentColor"
      }
    )
  );
}
function LineChevronRightThin() {
  return /* @__PURE__ */ React30.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE24,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React30.createElement("title", null, TITLE24),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 21H18L18 3H17L17 21ZM5.23732 20.2377L13.4749 11.9949L5.23757 3.7628L5.99988 3L15 11.9944L6.00012 21L5.23732 20.2377Z",
        fill: "currentColor"
      }
    )
  );
}
function LineChevronUpThin() {
  return /* @__PURE__ */ React30.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE24,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React30.createElement("title", null, TITLE24),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 7V6L3 6V7L21 7ZM20.2377 18.7627L11.9949 10.5251L3.7628 18.7624L3 18.0001L11.9944 9L21 17.9999L20.2377 18.7627Z",
        fill: "currentColor"
      }
    )
  );
}
function LineChevronDownThin() {
  return /* @__PURE__ */ React30.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE24,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React30.createElement("title", null, TITLE24),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 17V18H21V17H3ZM3.76231 5.23732L12.0051 13.4749L20.2372 5.23757L21 5.99988L12.0056 15L3 6.00012L3.76231 5.23732Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Link.tsx
import * as React31 from "react";
var TITLE25 = "Link";
function Link() {
  return /* @__PURE__ */ React31.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE25,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React31.createElement("title", null, TITLE25),
    /* @__PURE__ */ React31.createElement(
      "path",
      {
        d: "M3.78112 12C3.78112 10.5609 4.87554 9.39594 6.22747 9.39594L11.0343 9.39594V7.5L6.22747 7.5C3.88841 7.5 2 9.51015 2 12C2 14.4898 3.88841 16.5 6.22747 16.5L11.0343 16.5V14.6041L6.22747 14.6041C4.87554 14.6041 3.78112 13.4391 3.78112 12ZM17.7725 7.5L12.9657 7.5V9.39594L17.7725 9.39594C19.1245 9.39594 20.2189 10.5609 20.2189 12C20.2189 13.4391 19.1245 14.6041 17.7725 14.6041L12.9657 14.6041V16.5L17.7725 16.5C20.1116 16.5 22 14.4898 22 12C22 9.51015 20.1116 7.5 17.7725 7.5ZM6.91416 12C6.91416 12.5254 7.32189 12.9594 7.81545 12.9594L16.206 12.9594C16.6996 12.9594 17.1073 12.5254 17.1073 12C17.1073 11.4746 16.6996 11.0406 16.206 11.0406L7.81545 11.0406C7.32189 11.0406 6.91416 11.4746 6.91416 12Z",
        fill: "currentColor"
      }
    )
  );
}

// src/LinkedIn.tsx
import * as React32 from "react";
var TITLE26 = "LinkedIn";
function LinkedInFilled({ className }) {
  return /* @__PURE__ */ React32.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE26,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    },
    /* @__PURE__ */ React32.createElement("title", null, TITLE26),
    /* @__PURE__ */ React32.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM8.0625 9.1875H5.25V18.75H8.0625V9.1875ZM6.63206 8.0625H6.64781C7.51969 8.0625 8.0625 7.43644 8.0625 6.65569C8.04675 5.8575 7.51969 5.25 6.66412 5.25C5.80969 5.25 5.25 5.8575 5.25 6.65569C5.25 7.437 5.79281 8.0625 6.63206 8.0625ZM15.9375 18.75H18.75L18.7494 13.2791C18.7494 10.4531 17.2403 9.1875 15.2276 9.1875C13.6031 9.1875 12.9681 10.0312 12.5625 10.659V9.1875H9.75V18.75H12.5625V13.6875C12.5625 13.6406 12.5618 13.5858 12.561 13.5262C12.5573 13.2367 12.5521 12.8343 12.6193 12.6711C12.8409 12.1209 13.2977 11.5517 14.142 11.5517C15.2484 11.5517 15.9375 12.3954 15.9375 13.6318V18.75Z",
        fill: "currentColor"
      }
    )
  );
}
function LinkedIn({ className }) {
  return /* @__PURE__ */ React32.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": TITLE26,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    },
    /* @__PURE__ */ React32.createElement("title", null, TITLE26),
    /* @__PURE__ */ React32.createElement(
      "path",
      {
        d: "M7.13955 5.90917C6.96055 6.0806 6.74824 6.21341 6.51578 6.29937C6.28332 6.38533 6.03568 6.42261 5.78822 6.40888C5.54947 6.42029 5.31096 6.38174 5.08797 6.29569C4.86497 6.20965 4.66239 6.078 4.49319 5.90917C4.33413 5.7507 4.20855 5.56188 4.12392 5.35392C4.03928 5.14595 3.99732 4.9231 4.00052 4.6986C3.99484 4.47377 4.03567 4.25019 4.12045 4.04187C4.20523 3.83356 4.33213 3.64501 4.49319 3.48803C4.66979 3.32232 4.87798 3.1939 5.10532 3.11046C5.33267 3.02702 5.5745 2.99027 5.81637 3.0024C6.05509 2.98987 6.29384 3.02651 6.51782 3.11005C6.74179 3.19359 6.94622 3.32224 7.11843 3.48803C7.43729 3.81162 7.62099 4.24445 7.63222 4.6986C7.63582 4.92316 7.59404 5.14613 7.50939 5.35414C7.42473 5.56216 7.29893 5.75094 7.13955 5.90917V5.90917ZM4.08498 7.76724H7.51961V18.7679H4.08498V7.76724ZM9.52549 9.38602C9.52549 8.8042 9.50437 8.26461 9.46215 7.76724H12.4323L12.5941 9.30157H12.6575C12.9826 8.84796 13.3824 8.45289 13.8399 8.13323C14.4924 7.6923 15.2704 7.47497 16.0569 7.51387C16.5976 7.51311 17.1332 7.61832 17.6335 7.82355C18.1053 8.01653 18.5267 8.31509 18.8652 8.69628C19.2391 9.12775 19.5216 9.63055 19.6957 10.1743C19.9124 10.8566 20.0147 11.5701 19.9983 12.2858V18.782H16.5707V12.6658C16.5974 12.0682 16.4611 11.4747 16.1766 10.9485C16.0381 10.724 15.8392 10.5429 15.6028 10.426C15.3664 10.309 15.1018 10.2608 14.8393 10.2869C14.4213 10.2654 14.0116 10.4095 13.6991 10.6881C13.4306 10.9308 13.2211 11.2317 13.0868 11.5679C13.039 11.6918 13.0105 11.8224 13.0023 11.955V18.7609H9.56068V11.2793C9.56068 10.5896 9.54895 9.95846 9.52549 9.38602V9.38602Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Listen.tsx
import * as React33 from "react";
var TITLE27 = "Listen";
function Listen({ className }) {
  return /* @__PURE__ */ React33.createElement(
    "svg",
    {
      className,
      width: "16",
      height: "14",
      viewBox: "0 0 16 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE27,
      role: "img"
    },
    /* @__PURE__ */ React33.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1.10853C4.25623 1.10853 1.17073 4.03239 1.17073 7.69757V13.04H0V7.69757C0 3.49459 3.55379 0.0400391 8 0.0400391C12.4462 0.0400391 16 3.49459 16 7.69757V13.04H14.8293V7.69757C14.8293 4.03239 11.7438 1.10853 8 1.10853Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React33.createElement("rect", { y: "8", width: "2.5", height: "5", fill: "currentColor" }),
    /* @__PURE__ */ React33.createElement("rect", { x: "13.5", y: "8", width: "2.5", height: "5", fill: "currentColor" }),
    /* @__PURE__ */ React33.createElement("path", { d: "M6 13.96V7.95996L11 10.96L6 13.96Z", fill: "currentColor" })
  );
}

// src/Lock.tsx
import * as React34 from "react";
var TITLE28 = "Lock";
function Lock({ className, title }) {
  return /* @__PURE__ */ React34.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      "aria-label": TITLE28,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React34.createElement("title", null, title || TITLE28),
    /* @__PURE__ */ React34.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.5 7C9.5 5.61929 10.6193 4.5 12 4.5C13.3807 4.5 14.5 5.61929 14.5 7V9H9.5V7ZM7 9V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9H18C19.1046 9 20 9.89543 20 11V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V11C4 9.89543 4.89543 9 6 9H7Z",
        fill: "currentColor"
      }
    )
  );
}

// src/MinusStroke.tsx
import * as React35 from "react";
function MinusStroke({
  title = "MinusStroke",
  className
}) {
  return /* @__PURE__ */ React35.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      "aria-label": title,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React35.createElement("title", null, title),
    /* @__PURE__ */ React35.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6 11V13L18 13V11H6Z",
        fill: "currentColor"
      }
    )
  );
}

// src/NewWindow.tsx
import * as React36 from "react";
var TITLE29 = "New Window";
function NewWindow() {
  return /* @__PURE__ */ React36.createElement(
    "svg",
    {
      "aria-label": TITLE29,
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none"
    },
    /* @__PURE__ */ React36.createElement("title", null, TITLE29),
    /* @__PURE__ */ React36.createElement(
      "path",
      {
        d: "M12.6667 12.6667H3.33333V3.33333H8V2H2V14H14V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z",
        fill: "currentColor"
      }
    )
  );
}

// src/NotificationAdd.tsx
import * as React37 from "react";
function NotificationAdd({ className, title }) {
  return /* @__PURE__ */ React37.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": title
    },
    title && /* @__PURE__ */ React37.createElement("title", null, title),
    /* @__PURE__ */ React37.createElement(
      "path",
      {
        d: "M10.5 22C9.95 22 9.47917 21.8042 9.0875 21.4125C8.69583 21.0208 8.5 20.55 8.5 20H12.5C12.5 20.55 12.3042 21.0208 11.9125 21.4125C11.5208 21.8042 11.05 22 10.5 22ZM16.5 13V10H13.5V8H16.5V5H18.5V8H21.5V10H18.5V13H16.5ZM2.5 19V17H4.5V10C4.5 8.61667 4.91667 7.3875 5.75 6.3125C6.58333 5.2375 7.66667 4.53333 9 4.2V3.5C9 3.08333 9.14583 2.72917 9.4375 2.4375C9.72917 2.14583 10.0833 2 10.5 2C10.9167 2 11.2708 2.14583 11.5625 2.4375C11.8542 2.72917 12 3.08333 12 3.5V4.2C12.2333 4.26667 12.4625 4.3375 12.6875 4.4125C12.9125 4.4875 13.125 4.58333 13.325 4.7C13.075 4.93333 12.85 5.1875 12.65 5.4625C12.45 5.7375 12.275 6.03333 12.125 6.35C11.875 6.23333 11.6125 6.14583 11.3375 6.0875C11.0625 6.02917 10.7833 6 10.5 6C9.4 6 8.45833 6.39167 7.675 7.175C6.89167 7.95833 6.5 8.9 6.5 10V17H14.5V14.2C14.8 14.3833 15.1167 14.5333 15.45 14.65C15.7833 14.7667 16.1333 14.8583 16.5 14.925V17H18.5V19H2.5Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Pause.tsx
import * as React38 from "react";
var TITLE30 = "Pause";
function Pause({ className }) {
  return /* @__PURE__ */ React38.createElement(
    "svg",
    {
      className,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE30,
      role: "img"
    },
    /* @__PURE__ */ React38.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.375 1.59961H6.575V14.3996H2.375V1.59961ZM9.425 1.59961H13.625V14.3996H9.425V1.59961Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Play.tsx
import * as React39 from "react";
var TITLE31 = "Play";
function Play() {
  return /* @__PURE__ */ React39.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React39.createElement("title", null, TITLE31),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9 16L16 12L9 8L9 16Z",
        fill: "black"
      }
    )
  );
}

// src/Plus.tsx
import * as React40 from "react";
function PlusThin() {
  return /* @__PURE__ */ React40.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": "Plus Thin",
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React40.createElement("title", null, "Plus Thin"),
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 3H11.5V11.5H3V12.5H11.5V21H12.5V12.5H21V11.5H12.5V3Z",
        fill: "currentColor"
      }
    )
  );
}
function Plus({ className, title }) {
  const _title = title || "Plus";
  return /* @__PURE__ */ React40.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      "aria-label": _title,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React40.createElement("title", null, _title),
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 3H11V11H3V13H11V21H13V13H21V11H13V3Z",
        fill: "currentColor"
      }
    )
  );
}
function PlusStroke({ title = "Plus Stroke" }) {
  return /* @__PURE__ */ React40.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": title,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React40.createElement("title", null, title),
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 11V6H13V11H18V13H13V18H11V13H6V11H11Z",
        fill: "currentColor"
      }
    )
  );
}
function PlusThinStroke({
  title = "Plus Thin Stroke"
}) {
  return /* @__PURE__ */ React40.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      "aria-label": title,
      role: "img",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React40.createElement("title", null, title),
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.5 11.5V6H12.5V11.5H18V12.5H12.5V18H11.5V12.5H6V11.5H11.5Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Profile.tsx
import * as React41 from "react";
function UserAccountProfile({ className }) {
  return /* @__PURE__ */ React41.createElement(
    "svg",
    {
      className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      height: "100%",
      fill: "none",
      viewBox: "0 0 24 24"
    },
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm-2 2a8 8 0 0 0-8 8h20a8 8 0 0 0-8-8h-4Z",
        clipRule: "evenodd"
      }
    )
  );
}

// src/QR.tsx
import * as React42 from "react";
var TITLE32 = "QR Code";
function QR() {
  return /* @__PURE__ */ React42.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-label": TITLE32,
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React42.createElement("title", null, TITLE32),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 8H8V10H10V8ZM7 7V11H11V7H7ZM8 14H10V16H8V14ZM7 17V13H11V17H7ZM16 8H14V10H16V8ZM13 7V11H17V7H13ZM17 13H13V17H14V14H17V13Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Refresh.tsx
import React43 from "react";
var TITLE33 = "Refresh";
function Refresh() {
  return /* @__PURE__ */ React43.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    },
    /* @__PURE__ */ React43.createElement("title", null, TITLE33),
    /* @__PURE__ */ React43.createElement(
      "path",
      {
        d: "M12 20C9.76667 20 7.875 19.225 6.325 17.675C4.775 16.125 4 14.2333 4 12C4 9.76667 4.775 7.875 6.325 6.325C7.875 4.775 9.76667 4 12 4C13.15 4 14.25 4.23767 15.3 4.713C16.35 5.18767 17.25 5.86667 18 6.75V4H20V11H13V9H17.2C16.6667 8.06667 15.9377 7.33333 15.013 6.8C14.0877 6.26667 13.0833 6 12 6C10.3333 6 8.91667 6.58333 7.75 7.75C6.58333 8.91667 6 10.3333 6 12C6 13.6667 6.58333 15.0833 7.75 16.25C8.91667 17.4167 10.3333 18 12 18C13.2833 18 14.4417 17.6333 15.475 16.9C16.5083 16.1667 17.2333 15.2 17.65 14H19.75C19.2833 15.7667 18.3333 17.2083 16.9 18.325C15.4667 19.4417 13.8333 20 12 20Z",
        fill: "black"
      }
    )
  );
}

// src/Search.tsx
import * as React44 from "react";
var TITLE34 = "Search";
function Search({ className }) {
  return /* @__PURE__ */ React44.createElement(
    "svg",
    {
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE34
    },
    /* @__PURE__ */ React44.createElement("title", null, TITLE34),
    /* @__PURE__ */ React44.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 20.1125C21 19.8689 20.9095 19.6566 20.7285 19.4756L15.7587 14.4849C16.232 13.8863 16.6009 13.2146 16.8654 12.4698C17.1299 11.7251 17.2622 10.942 17.2622 10.1206C17.2622 9.14617 17.0742 8.2239 16.6984 7.35383C16.3225 6.48375 15.8109 5.72854 15.1636 5.08817C14.5162 4.44779 13.761 3.93968 12.8979 3.56381C12.0348 3.18793 11.1091 3 10.1206 3C9.14617 3 8.2239 3.18793 7.35383 3.56381C6.48375 3.93968 5.72854 4.44779 5.08817 5.08817C4.44779 5.72854 3.93968 6.48375 3.56381 7.35383C3.18793 8.2239 3 9.14617 3 10.1206C3 11.1091 3.18793 12.0348 3.56381 12.8979C3.93968 13.761 4.44779 14.5162 5.08817 15.1636C5.72854 15.8109 6.48375 16.3225 7.35383 16.6984C8.2239 17.0742 9.14617 17.2622 10.1206 17.2622C10.942 17.2622 11.7251 17.1299 12.4698 16.8654C13.2146 16.6009 13.8863 16.232 14.4849 15.7587L19.4756 20.7285C19.5731 20.826 19.6775 20.8956 19.7889 20.9374C19.9002 20.9791 20.0046 21 20.1021 21C20.2135 21 20.3248 20.9791 20.4362 20.9374C20.5476 20.8956 20.645 20.826 20.7285 20.7285C20.9095 20.5615 21 20.3561 21 20.1125ZM5.203 12.1984C4.91762 11.551 4.77493 10.8584 4.77493 10.1206C4.77493 9.39672 4.91762 8.70764 5.203 8.05334C5.48839 7.39904 5.87121 6.83177 6.35149 6.35148C6.83177 5.8712 7.39905 5.48838 8.05335 5.20299C8.70764 4.91761 9.39673 4.77492 10.1206 4.77492C10.8585 4.77492 11.551 4.91761 12.1984 5.20299C12.8457 5.48838 13.413 5.8712 13.9002 6.35148C14.3875 6.83177 14.7703 7.39904 15.0487 8.05334C15.3271 8.70764 15.4663 9.39672 15.4663 10.1206C15.4663 10.8584 15.3271 11.551 15.0487 12.1984C14.7703 12.8457 14.3875 13.413 13.9002 13.9002C13.413 14.3874 12.8457 14.7703 12.1984 15.0487C11.551 15.3271 10.8585 15.4663 10.1206 15.4663C9.39673 15.4663 8.70764 15.3271 8.05335 15.0487C7.39905 14.7703 6.83177 14.3874 6.35149 13.9002C5.87121 13.413 5.48839 12.8457 5.203 12.1984Z",
        fill: "currentColor"
      }
    )
  );
}

// src/ShareDrawer.tsx
import * as React45 from "react";
var TITLE35 = "Share";
function ShareDrawer({ darkMode = false }) {
  return /* @__PURE__ */ React45.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 14 18",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE35
    },
    /* @__PURE__ */ React45.createElement("title", null, TITLE35),
    /* @__PURE__ */ React45.createElement(
      "path",
      {
        d: "M6.55916 0.730957L2.39505 3.99223L3.01164 4.77951L6.05916 2.39274V9.99411H7.05916V2.39274L10.1067 4.77951L10.7233 3.99223L6.55916 0.730957Z",
        fill: darkMode ? "white" : "black"
      }
    ),
    /* @__PURE__ */ React45.createElement(
      "path",
      {
        d: "M0 8.91551V14.808H13.1183V8.91551H12.1183V13.808H1V8.91551H0Z",
        fill: darkMode ? "white" : "black"
      }
    )
  );
}

// src/Spotify.tsx
import * as React46 from "react";
var TITLE36 = "Spotify";
function Spotify() {
  return /* @__PURE__ */ React46.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-label": TITLE36,
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React46.createElement("title", null, TITLE36),
    /* @__PURE__ */ React46.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1.97998C10.0222 1.97998 8.08879 2.56647 6.4443 3.66528C4.79981 4.7641 3.51809 6.32588 2.76121 8.15314C2.00434 9.98041 1.8063 11.9911 2.19215 13.9309C2.578 15.8707 3.53041 17.6525 4.92894 19.051C6.32746 20.4496 8.10929 21.402 10.0491 21.7878C11.9889 22.1737 13.9996 21.9756 15.8268 21.2188C17.6541 20.4619 19.2159 19.1802 20.3147 17.5357C21.4135 15.8912 22 13.9578 22 11.98C22 9.32782 20.9464 6.78428 19.0711 4.90891C17.1957 3.03355 14.6522 1.97998 12 1.97998ZM16.58 16.4C16.5379 16.4708 16.4821 16.5326 16.4158 16.5816C16.3495 16.6307 16.2742 16.666 16.1941 16.6855C16.114 16.7051 16.0308 16.7085 15.9494 16.6955C15.868 16.6825 15.79 16.6535 15.72 16.61C13.38 15.17 10.42 14.85 6.94001 15.61C6.86056 15.6284 6.77826 15.6309 6.69783 15.6175C6.61739 15.6041 6.54038 15.575 6.4712 15.5318C6.40202 15.4886 6.34203 15.4322 6.29464 15.3658C6.24725 15.2995 6.21339 15.2244 6.195 15.145C6.17662 15.0655 6.17406 14.9832 6.18748 14.9028C6.2009 14.8224 6.23003 14.7454 6.27321 14.6762C6.31639 14.607 6.37277 14.547 6.43914 14.4996C6.5055 14.4522 6.58056 14.4184 6.66001 14.4C10.47 13.53 13.74 13.9 16.38 15.51C16.456 15.5537 16.5221 15.6129 16.5739 15.6836C16.6258 15.7543 16.6623 15.8351 16.6811 15.9208C16.6999 16.0064 16.7006 16.0951 16.6832 16.1811C16.6658 16.267 16.6307 16.3484 16.58 16.42V16.4ZM17.81 13.68C17.7004 13.8567 17.5256 13.9832 17.3234 14.0319C17.1212 14.0805 16.908 14.0475 16.73 13.94C15.2237 13.0925 13.564 12.5526 11.8474 12.3518C10.1307 12.1509 8.39127 12.2931 6.73001 12.77C6.6303 12.8039 6.52474 12.8173 6.41972 12.8093C6.3147 12.8013 6.21238 12.7722 6.11894 12.7236C6.02549 12.675 5.94286 12.608 5.87601 12.5266C5.80917 12.4452 5.7595 12.3511 5.73001 12.25C5.69459 12.1503 5.68006 12.0445 5.68735 11.939C5.69464 11.8335 5.72357 11.7306 5.77236 11.6368C5.82114 11.543 5.88874 11.4602 5.97091 11.3937C6.05309 11.3271 6.14809 11.2782 6.25 11.25C8.11611 10.7126 10.0708 10.5535 11.9992 10.7819C13.9277 11.0103 15.7911 11.6216 17.48 12.58C17.6561 12.6876 17.7823 12.8607 17.8311 13.0613C17.8798 13.2618 17.847 13.4735 17.74 13.65L17.81 13.68ZM17.91 10.84C14.69 8.92998 9.37001 8.74998 6.29001 9.68998C6.05264 9.76159 5.79654 9.73597 5.57806 9.61876C5.35958 9.50155 5.19661 9.30235 5.125 9.06498C5.0534 8.82761 5.07901 8.57151 5.19622 8.35303C5.31344 8.13456 5.51264 7.97159 5.75 7.89998C9.28 6.81998 15.16 7.02998 18.87 9.22998C19.0835 9.35864 19.2371 9.56682 19.2971 9.80872C19.3571 10.0506 19.3186 10.3065 19.19 10.52C19.1272 10.6253 19.0443 10.7172 18.9459 10.7904C18.8475 10.8636 18.7355 10.9165 18.6166 10.9463C18.4976 10.976 18.3739 10.9819 18.2527 10.9637C18.1314 10.9455 18.015 10.9034 17.91 10.84Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Stitcher.tsx
import * as React47 from "react";
var TITLE37 = "Stitcher";
function Stitcher() {
  return /* @__PURE__ */ React47.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-label": TITLE37,
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React47.createElement("title", null, TITLE37),
    /* @__PURE__ */ React47.createElement("path", { d: "M1 8.815H4.85V15.8H1V8.815Z", fill: "currentColor" }),
    /* @__PURE__ */ React47.createElement("path", { d: "M19.15 8.43H23V14.865H19.15V8.43Z", fill: "currentColor" }),
    /* @__PURE__ */ React47.createElement("path", { d: "M14.64 7H18.49V15.36H14.64V7Z", fill: "currentColor" }),
    /* @__PURE__ */ React47.createElement("path", { d: "M10.13 8.21H13.98V16.24H10.13V8.21Z", fill: "currentColor" }),
    /* @__PURE__ */ React47.createElement("path", { d: "M5.565 7.55H9.415V15.305H5.565V7.55Z", fill: "currentColor" })
  );
}

// src/Terminal.tsx
import * as React48 from "react";
var TITLE38 = "Bloomberg Terminal";
function Terminal({ className }) {
  return /* @__PURE__ */ React48.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      "aria-label": TITLE38,
      xmlns: "http://www.w3.org/2000/svg",
      className
    },
    /* @__PURE__ */ React48.createElement("title", null, TITLE38),
    /* @__PURE__ */ React48.createElement(
      "path",
      {
        d: "M12.7876 16.67L12.4287 16.6501V17.6072C12.4088 17.6271 12.2891 17.7069 11.99 17.7069C11.6909 17.7069 11.5713 17.6271 11.5513 17.6072V16.6501L11.1924 16.6899C9.43769 16.8495 8.3011 17.5075 8.3011 18.325C8.3011 19.3021 9.85643 20 11.99 20C14.1236 20 15.679 19.3021 15.679 18.325C15.679 17.4875 14.5424 16.8495 12.7876 16.67ZM11.5314 14.2223V7.77767C11.5314 7.33898 11.1725 7 10.7537 7H2.77767C2.33898 7 2 7.33898 2 7.77767V14.2223C2 14.6411 2.33898 15 2.77767 15H10.7537C11.1725 15 11.5314 14.6411 11.5314 14.2223ZM22 7.77767C22 7.35892 21.661 7 21.2223 7H13.2463C12.8275 7 12.4686 7.33898 12.4686 7.77767V14.2223C12.4686 14.6411 12.8076 15 13.2463 15H21.2223C21.6411 15 22 14.661 22 14.2223V7.77767Z",
        fill: "currentColor"
      }
    )
  );
}

// src/TerminalWhite.tsx
import * as React49 from "react";
var TITLE39 = "Bloomberg Terminal";
function TerminalWhite({ className }) {
  return /* @__PURE__ */ React49.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      "aria-label": TITLE39,
      xmlns: "http://www.w3.org/2000/svg",
      className
    },
    /* @__PURE__ */ React49.createElement("title", null, TITLE39),
    /* @__PURE__ */ React49.createElement(
      "path",
      {
        d: "M9.52381 14.3579V14.8212C9.52381 15.0842 9.73701 15.2974 10 15.2974C10.263 15.2974 10.4762 15.0842 10.4762 14.8212V14.3579C12.3554 14.4604 13.8095 15.1618 13.8095 16.0118C13.8095 16.9323 12.1039 17.6786 10 17.6786C7.89606 17.6786 6.19048 16.9323 6.19048 16.0118C6.19048 15.1618 7.64461 14.4604 9.52381 14.3579ZM6.90476 16.0118C6.90476 16.037 6.92741 16.0854 7.00338 16.164C7.12375 16.2886 7.3248 16.4188 7.59256 16.5359C8.2064 16.8045 9.06949 16.9642 10 16.9642C10.9305 16.9642 11.7936 16.8045 12.4074 16.5359C12.6752 16.4188 12.8763 16.2886 12.9966 16.164C13.0726 16.0854 13.0952 16.037 13.0952 16.0118C13.0952 15.7483 12.3174 15.3236 11.1462 15.1441C11.0054 15.6447 10.5456 16.0118 10 16.0118C9.45443 16.0118 8.99458 15.6447 8.85384 15.1441C7.68255 15.3236 6.90476 15.7483 6.90476 16.0118ZM0.952381 4.82141H8.57143C9.09741 4.82141 9.52381 5.24781 9.52381 5.77379V12.4607C9.52381 12.9866 9.09741 13.413 8.57143 13.413H0.952381C0.426395 13.413 0 12.9866 0 12.4607V5.77379C0 5.24781 0.426395 4.82141 0.952381 4.82141ZM0.952381 5.77604V12.4584H8.57143V5.77604H0.952381ZM11.4286 4.82141H19.0476C19.5736 4.82141 20 5.24781 20 5.77379V12.4607C20 12.9866 19.5736 13.413 19.0476 13.413H11.4286C10.9026 13.413 10.4762 12.9866 10.4762 12.4607V5.77379C10.4762 5.24781 10.9026 4.82141 11.4286 4.82141ZM11.4286 5.77604V12.4584H19.0476V5.77604H11.4286Z",
        fill: "currentColor"
      }
    )
  );
}

// src/TheWeekend.tsx
import * as React50 from "react";
var TITLE40 = "Weekend Logo";
function WeekendLogo({ className }) {
  return /* @__PURE__ */ React50.createElement(
    "svg",
    {
      className,
      width: "259",
      height: "48",
      viewBox: "0 0 259 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": TITLE40,
      role: "img"
    },
    /* @__PURE__ */ React50.createElement(
      "path",
      {
        d: "M17.6723 47L6.11122 12.4384C4.77256 8.60503 4.28578 7.38808 2.46035 6.96214L0.939152 6.6579V4.83247H21.6883V6.6579L20.2279 7.02299C18.9501 7.38808 18.2199 7.99655 18.2199 9.39605C18.2199 10.6739 18.7067 12.3776 19.3152 14.1422L25.5825 34.3437H25.8868L31.2414 17.8539L29.1725 11.3432C28.3207 8.66588 27.5296 7.57062 25.7651 7.02299L24.4873 6.6579V4.83247H45.1755V6.6579L42.985 7.14468C41.7072 7.38808 41.0987 8.23994 41.0987 9.63944C41.0987 10.7956 41.4638 12.3167 42.0114 14.1422L48.2787 34.3437H48.583L54.4852 14.0813C55.0329 12.4384 55.3371 10.9172 55.3371 9.63944C55.3371 8.0574 54.4852 7.32723 53.0857 7.02299L51.1386 6.6579V4.83247H63.8558V6.6579L62.578 6.96214C60.57 7.50977 59.779 9.33521 58.1969 13.8988L47.6703 47H40.5511L33.0668 22.9651H32.8234L24.9132 47H17.6723ZM73.7255 47.7302C63.0163 47.7302 57.6008 41.5237 57.6008 31.0579C57.6008 20.2878 65.6936 14.4464 73.7255 14.4464C82.3659 14.4464 87.7205 18.6449 87.9639 29.6584H67.9449C68.1883 39.5766 71.8392 42.1322 78.1065 42.1322C81.6966 42.1322 84.6172 41.0978 86.9295 39.8808V41.9496C84.6781 44.5052 79.9928 47.7302 73.7255 47.7302ZM73.1779 16.8803C70.318 16.8803 68.1883 19.5576 67.9449 27.2853L77.5589 26.7377C77.5589 19.3751 76.5853 16.8803 73.1779 16.8803ZM104.285 47.7302C93.5757 47.7302 88.1602 41.5237 88.1602 31.0579C88.1602 20.2878 96.253 14.4464 104.285 14.4464C112.925 14.4464 118.28 18.6449 118.523 29.6584H98.5043C98.7477 39.5766 102.399 42.1322 108.666 42.1322C112.256 42.1322 115.177 41.0978 117.489 39.8808V41.9496C115.237 44.5052 110.552 47.7302 104.285 47.7302ZM103.737 16.8803C100.877 16.8803 98.7477 19.5576 98.5043 27.2853L108.118 26.7377C108.118 19.3751 107.145 16.8803 103.737 16.8803ZM142.085 47C138.617 41.9496 135.574 36.4733 133.445 32.1531V30.997L140.26 23.7561C142.207 21.5656 142.572 20.3487 142.572 19.2534C142.572 18.219 141.842 17.6714 140.199 17.2454L139.347 17.002V15.2374H153.22V17.002L152.064 17.3063C150.482 17.7322 149.509 18.219 146.649 21.0788L141.355 26.3726C144.458 32.2748 148.535 39.2723 151.334 42.984C152.064 44.0185 152.794 44.6269 153.829 44.9312L154.681 45.2354V47H142.085ZM118.233 47V45.2354L119.632 44.8703C121.823 44.2618 122.005 44.0185 122.005 41.2803V9.15266C122.005 6.11027 121.884 5.74518 120.058 4.83247L117.929 3.73721V2.21601L132.045 0.938207L132.775 1.48584C132.775 1.48584 132.593 4.52823 132.593 8.60503V41.2803C132.593 44.201 132.775 44.3835 134.601 44.9312L135.696 45.2354V47H118.233ZM170.217 47.7302C159.508 47.7302 154.092 41.5237 154.092 31.0579C154.092 20.2878 162.185 14.4464 170.217 14.4464C178.857 14.4464 184.212 18.6449 184.455 29.6584H164.436C164.68 39.5766 168.331 42.1322 174.598 42.1322C178.188 42.1322 181.109 41.0978 183.421 39.8808V41.9496C181.169 44.5052 176.484 47.7302 170.217 47.7302ZM169.669 16.8803C166.809 16.8803 164.68 19.5576 164.436 27.2853L174.05 26.7377C174.05 19.3751 173.077 16.8803 169.669 16.8803ZM184.165 47V45.2354L185.564 44.8703C187.755 44.2618 187.937 44.0185 187.937 41.2803V22.7217C187.937 20.1053 187.694 19.8619 185.929 18.5841L183.921 17.1846V15.9068L197.551 14.4464L198.281 14.9332L198.16 18.8883H198.403C201.628 16.5152 205.583 14.4464 210.147 14.4464C215.136 14.4464 218.118 17.1237 218.118 22.6V41.2803C218.118 44.0793 218.361 44.3227 220.491 44.8703L221.89 45.2354V47H204.184V45.2354L205.461 44.9312C207.409 44.3835 207.53 44.2618 207.53 41.2803V25.2165C207.53 21.6265 206.192 20.5312 203.575 20.5312C201.567 20.5312 199.742 20.8963 198.525 21.1397V41.2803C198.525 44.3227 198.647 44.3835 200.594 44.9312L201.871 45.2354V47H184.165ZM233.678 47.7302C227.593 47.7302 221.812 43.1666 221.812 32.214C221.812 19.3751 229.966 14.4464 239.641 14.4464C241.04 14.4464 242.744 14.7507 244.022 15.0549C244.022 15.0549 243.961 12.9252 243.961 10.7347V9.15266C243.961 6.23197 243.596 5.98858 242.014 5.07586L239.519 3.73721V2.21601L253.94 0.938207L254.67 1.48584C254.67 1.48584 254.488 4.40653 254.488 8.60503V39.4549C254.488 42.4973 254.609 42.8015 256.496 43.5925L258.139 44.2618V45.8439L244.874 47.7302L244.144 47.2434L244.265 43.7142H243.961C241.345 45.9656 238.059 47.7302 233.678 47.7302ZM239.215 42.5581C241.466 42.5581 243.048 41.7062 243.9 41.402V19.4968C242.927 18.2798 241.527 17.002 239.458 17.002C235.442 17.002 232.643 20.0444 232.643 30.0843C232.643 39.6374 234.895 42.5581 239.215 42.5581Z",
        fill: "black"
      }
    )
  );
}

// src/Translate.tsx
import * as React51 from "react";
function Translate({ className }) {
  return /* @__PURE__ */ React51.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    },
    /* @__PURE__ */ React51.createElement(
      "path",
      {
        d: "M8.13338 14.4L10.9834 6.79998H12.35L15.2 14.4H13.8834L13.2 12.45H10.1334L9.45005 14.4H8.13338ZM2.81672 12.4L1.98338 11.55L5.18338 8.38331C4.78338 7.96109 4.41116 7.5222 4.06672 7.06664C3.72227 6.61109 3.42227 6.11664 3.16672 5.58331H4.53338C4.73338 5.93886 4.93338 6.24164 5.13338 6.49164C5.33338 6.74164 5.62227 7.07775 6.00005 7.49998C6.42227 7.03331 6.81116 6.5472 7.16672 6.04164C7.52227 5.53609 7.81116 4.98886 8.03338 4.39998H0.800049V3.19998H5.40005V1.59998H6.60005V3.19998H11.2V4.39998H9.30005C9.06672 5.16664 8.72783 5.87498 8.28338 6.52498C7.83894 7.17498 7.35005 7.79442 6.81672 8.38331L8.33338 9.88331L7.86671 11.1166L6.00005 9.24998L2.81672 12.4ZM10.5334 11.35H12.8L11.7 8.19998L10.5334 11.35Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Triangle.tsx
import * as React52 from "react";
function Triangle({ className }) {
  return /* @__PURE__ */ React52.createElement(
    "svg",
    {
      width: "9",
      height: "6",
      viewBox: "0 0 9 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className
    },
    /* @__PURE__ */ React52.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 5.5L0 5.5L4.5 0.5L9 5.5Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Tune.tsx
import * as React53 from "react";
function Tune({ className, title }) {
  return /* @__PURE__ */ React53.createElement(
    "svg",
    {
      className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 16 16",
      fill: "none"
    },
    title && /* @__PURE__ */ React53.createElement("title", null, title),
    /* @__PURE__ */ React53.createElement(
      "path",
      {
        d: "M7.33333 14V10H8.66667V11.3333H14V12.6667H8.66667V14H7.33333ZM2 12.6667V11.3333H6V12.6667H2ZM4.66667 10V8.66667H2V7.33333H4.66667V6H6V10H4.66667ZM7.33333 8.66667V7.33333H14V8.66667H7.33333ZM10 6V2H11.3333V3.33333H14V4.66667H11.3333V6H10ZM2 4.66667V3.33333H8.66667V4.66667H2Z",
        fill: "currentColor"
      }
    )
  );
}

// src/TuneIn.tsx
import * as React54 from "react";
var TITLE41 = "TuneIn";
function TuneIn() {
  return /* @__PURE__ */ React54.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-label": TITLE41,
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React54.createElement("title", null, TITLE41),
    /* @__PURE__ */ React54.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.38 11.27V11.88C8.38 11.9039 8.37052 11.9268 8.35364 11.9436C8.33676 11.9605 8.31387 11.97 8.29 11.97H7.59C7.59 11.97 7.49 11.97 7.49 12.06V15.42C7.49143 15.4313 7.49042 15.4428 7.48704 15.4537C7.48366 15.4646 7.478 15.4746 7.47042 15.4832C7.46284 15.4917 7.45353 15.4985 7.44311 15.5031C7.43269 15.5077 7.4214 15.5101 7.41 15.51H6.69C6.61 15.51 6.61 15.42 6.61 15.42V12.06C6.61008 12.0473 6.60746 12.0347 6.60233 12.0231C6.59719 12.0115 6.58966 12.001 6.58021 11.9925C6.57076 11.984 6.55962 11.9776 6.54752 11.9738C6.53542 11.9699 6.52263 11.9686 6.51 11.97H5.81C5.78613 11.97 5.76324 11.9605 5.74636 11.9436C5.72948 11.9268 5.72 11.9039 5.72 11.88V11.27C5.72 11.2461 5.72948 11.2232 5.74636 11.2064C5.76324 11.1895 5.78613 11.18 5.81 11.18H8.38V11.27ZM21.27 5H12.27C11.7 5 11.57 5.13 11.57 5.68V7.68C11.57 8.09 11.57 8.09 11.16 8.09H2.68C2.11 8.1 2 8.21 2 8.77V13.28C2 14.77 2 16.22 2 17.68C2 18.45 2.08 18.53 2.87 18.53H11.87C12.27 18.53 12.42 18.36 12.42 17.96V15.83C12.42 15.43 12.42 15.43 12.81 15.43H21.31C21.84 15.43 21.97 15.31 21.97 14.78V5.71C21.97 5.13 21.83 5 21.23 5H21.27ZM11.56 17.19C11.56 17.6 11.56 17.6 11.13 17.6H3.26C2.99 17.6 2.9 17.53 2.9 17.25C2.9 14.62 2.9 11.98 2.9 9.35C2.9 9.07 2.97 8.98 3.27 8.98H11.27H11.6C11.6 9.13 11.6 9.24 11.6 9.34C11.6 11.94 11.6 14.55 11.6 17.15L11.56 17.19ZM18 12.32C18 12.3412 17.9916 12.3616 17.9766 12.3766C17.9616 12.3916 17.9412 12.4 17.92 12.4H15.74C15.7188 12.4 15.6984 12.3916 15.6834 12.3766C15.6684 12.3616 15.66 12.3412 15.66 12.32V11.77C15.6586 11.7587 15.6596 11.7472 15.663 11.7363C15.6663 11.7254 15.672 11.7154 15.6796 11.7068C15.6872 11.6983 15.6965 11.6915 15.7069 11.6869C15.7173 11.6823 15.7286 11.6799 15.74 11.68H16.26C16.2812 11.68 16.3016 11.6716 16.3166 11.6566C16.3316 11.6416 16.34 11.6212 16.34 11.6V8.98C16.34 8.95878 16.3316 8.93843 16.3166 8.92343C16.3016 8.90843 16.2812 8.9 16.26 8.9H15.83C15.8139 8.90173 15.7976 8.89909 15.7829 8.89236C15.7682 8.88563 15.7556 8.87505 15.7464 8.86175C15.7372 8.84844 15.7317 8.83289 15.7306 8.81675C15.7295 8.8006 15.7327 8.78445 15.74 8.77V8.13C15.74 8.10613 15.7495 8.08324 15.7664 8.06636C15.7832 8.04948 15.8061 8.04 15.83 8.04H17.83C17.8539 8.04 17.8768 8.04948 17.8936 8.06636C17.9105 8.08324 17.92 8.10613 17.92 8.13V8.77C17.92 8.85 17.83 8.85 17.83 8.85H17.4C17.3886 8.84991 17.3773 8.85226 17.3669 8.85689C17.3565 8.86152 17.3472 8.86833 17.3396 8.87685C17.332 8.88537 17.3263 8.89542 17.323 8.90631C17.3196 8.9172 17.3186 8.92869 17.32 8.94V11.5C17.32 11.5 17.32 11.59 17.4 11.59H17.92C17.9412 11.59 17.9616 11.5984 17.9766 11.6134C17.9916 11.6284 18 11.6488 18 11.67V12.32Z",
        fill: "currentColor"
      }
    )
  );
}

// src/Twitter.tsx
import * as React55 from "react";
var TITLE42 = "Twitter";
function Twitter({ className }) {
  return /* @__PURE__ */ React55.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE42,
      className
    },
    /* @__PURE__ */ React55.createElement("title", null, TITLE42),
    /* @__PURE__ */ React55.createElement(
      "path",
      {
        d: "M22 5.75994C21.8663 5.96888 21.7242 6.16947 21.5654 6.37005C21.4091 6.56883 21.2417 6.75857 21.0639 6.93838C20.8884 7.11389 20.6962 7.2894 20.5207 7.43984C20.3452 7.59028 20.1446 7.74908 19.9356 7.91623V8.16696C19.9442 8.26428 19.9442 8.36216 19.9356 8.45948C19.9272 9.86509 19.6667 11.2578 19.1667 12.5715C18.6768 13.9535 17.9375 15.234 16.9854 16.3492C15.9538 17.5038 14.7003 18.439 13.2996 19.0988C11.7309 19.8304 10.0156 20.1935 8.285 20.1603C7.72589 20.157 7.16757 20.1179 6.61346 20.0433C6.06192 19.9687 5.51702 19.8514 4.9837 19.6922C4.44731 19.5412 3.92451 19.3455 3.42081 19.1072C2.92938 18.8601 2.45476 18.5809 2 18.2714H2.96949C3.44825 18.2708 3.92617 18.2316 4.39866 18.1544C4.82812 18.0913 5.25066 17.9877 5.66068 17.8452C6.09688 17.7169 6.51737 17.5403 6.91433 17.3187C7.30653 17.0994 7.67607 16.8418 8.01755 16.5497C7.14915 16.5497 6.30645 16.2551 5.62725 15.714C5.28446 15.4765 4.98721 15.1792 4.74969 14.8364C4.49845 14.4784 4.30393 14.0837 4.173 13.6663C4.30262 13.6939 4.4338 13.7134 4.56582 13.7248C4.69663 13.733 4.82782 13.733 4.95863 13.7248C5.13951 13.7368 5.321 13.7368 5.50188 13.7248C5.68528 13.6975 5.86673 13.6584 6.04513 13.6078C5.11309 13.4476 4.27506 12.9436 3.69661 12.1954C3.38066 11.8467 3.1339 11.4411 2.96949 11.0002C2.80046 10.5428 2.71552 10.0587 2.71876 9.57106L3.17008 9.78L3.61304 9.9388L4.09778 10.0224C4.25901 10.0376 4.42131 10.0376 4.58253 10.0224C4.31379 9.83314 4.06461 9.61756 3.8387 9.37883C3.60412 9.13014 3.40703 8.84859 3.25366 8.54306C3.09569 8.24515 2.96962 7.93139 2.87756 7.607C2.80195 7.29527 2.76823 6.97485 2.77727 6.65422C2.7667 6.48444 2.7667 6.31417 2.77727 6.1444C2.80462 5.961 2.8437 5.77954 2.89427 5.60115C2.94442 5.44235 3.01128 5.28355 3.06979 5.1164C3.13396 4.9455 3.21812 4.78278 3.32052 4.63165C3.8146 5.24855 4.37516 5.80912 4.99206 6.30319C5.63366 6.81165 6.32865 7.24882 7.06477 7.607C7.77495 7.99761 8.52987 8.3007 9.313 8.50963C10.1332 8.72561 10.9733 8.85723 11.8203 8.90244C11.7922 8.74483 11.7726 8.58579 11.7618 8.42605V7.94966C11.7583 7.39963 11.8634 6.85431 12.071 6.34498C12.2613 5.8622 12.5454 5.42191 12.9068 5.04954C13.2956 4.68628 13.7418 4.38977 14.2273 4.17198C14.7328 3.94918 15.2796 3.83527 15.832 3.83767C16.1136 3.83817 16.3941 3.87183 16.6678 3.93796C16.9523 4.00034 17.2317 4.08416 17.5036 4.18869C17.7621 4.2943 18.0064 4.43188 18.2307 4.59822C18.4448 4.7609 18.6485 4.93675 18.8408 5.12476C19.0612 5.09688 19.2791 5.05217 19.4927 4.99103C19.7232 4.92955 19.9472 4.84557 20.1613 4.7403C20.3702 4.65672 20.5792 4.57315 20.7881 4.4645L21.415 4.15526C21.3343 4.39055 21.2366 4.6196 21.1224 4.84059C21.0079 5.05789 20.8706 5.26241 20.7129 5.45071C20.5669 5.65022 20.3987 5.83248 20.2115 5.99396C20.0284 6.15427 19.8328 6.29961 19.6264 6.42856C19.8354 6.42856 20.0359 6.37005 20.2365 6.32827C20.4371 6.28648 20.6377 6.24469 20.8466 6.18619C21.0399 6.13416 21.2298 6.06995 21.415 5.99396L22 5.75994Z",
        fill: "currentColor"
      }
    )
  );
}

// src/VisibilityOff.tsx
import * as React56 from "react";
var TITLE43 = "Visibility Off";
function VisibilityOff() {
  return /* @__PURE__ */ React56.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 0 24 24",
      width: "24px",
      fill: "currentColor",
      role: "img",
      "aria-label": TITLE43
    },
    /* @__PURE__ */ React56.createElement("title", null, TITLE43),
    /* @__PURE__ */ React56.createElement(
      "path",
      {
        d: "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z",
        fill: "none"
      }
    ),
    /* @__PURE__ */ React56.createElement("path", { d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z" })
  );
}

// src/VisibilityOn.tsx
import * as React57 from "react";
var TITLE44 = "Visibility On";
function VisibilityOn() {
  return /* @__PURE__ */ React57.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 0 24 24",
      width: "24px",
      fill: "currentColor",
      role: "img",
      "aria-label": TITLE44
    },
    /* @__PURE__ */ React57.createElement("title", null, TITLE44),
    /* @__PURE__ */ React57.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
    /* @__PURE__ */ React57.createElement("path", { d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" })
  );
}

// src/X.tsx
import * as React58 from "react";
var TITLE45 = "X";
function X({ className }) {
  return /* @__PURE__ */ React58.createElement(
    "svg",
    {
      "aria-label": TITLE45,
      className,
      fill: "none",
      height: "24",
      role: "img",
      viewBox: "0 0 24 24",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React58.createElement("title", null, TITLE45),
    /* @__PURE__ */ React58.createElement(
      "path",
      {
        d: "M17.175 4h2.761l-6.031 6.777L21 20h-5.554l-4.353-5.592L6.117 20H3.352l6.45-7.25L3 4h5.695l3.93 5.112L17.176 4Zm-.97 14.377h1.529L7.862 5.538H6.219l9.986 12.839Z",
        fill: "currentColor"
      }
    )
  );
}

// src/YouTube.tsx
import * as React59 from "react";
var TITLE46 = "YouTube";
function YouTube({ className }) {
  return /* @__PURE__ */ React59.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": TITLE46,
      className
    },
    /* @__PURE__ */ React59.createElement("title", null, TITLE46),
    /* @__PURE__ */ React59.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.9356 6.06695C21.2459 6.37724 21.4687 6.76306 21.5818 7.18581C22 8.74613 22 12 22 12C22 12 22 15.2539 21.5818 16.8142C21.4687 17.2369 21.2459 17.6228 20.9356 17.933C20.6253 18.2433 20.2384 18.4672 19.8136 18.5823C18.25 19 12 19 12 19C12 19 5.75 19 4.18636 18.5823C3.76161 18.4672 3.37472 18.2433 3.06441 17.933C2.7541 17.6228 2.53125 17.2369 2.41818 16.8142C2 15.2539 2 12 2 12C2 12 2 8.74613 2.41818 7.18581C2.53125 6.76306 2.7541 6.37724 3.06441 6.06695C3.37472 5.75666 3.76161 5.53279 4.18636 5.41774C5.75 5 12 5 12 5C12 5 18.25 5 19.8136 5.41774C20.2384 5.53279 20.6253 5.75666 20.9356 6.06695ZM15 12L10 15V9L15 12Z",
        fill: "currentColor"
      }
    )
  );
}
export {
  AdChoices,
  Apple,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  BloombergLogo,
  BloombergLogoSmall,
  BloombergLogoUK,
  BloombergLogoWeekend,
  BookmarkFilled,
  BookmarkStroke,
  BusinessweekLogo,
  Checkmark,
  CheckmarkFilled,
  CheckmarkStroke,
  ChevronDown,
  ChevronDownThin,
  ChevronLeft,
  ChevronLeftThin,
  ChevronRight,
  ChevronRightThin,
  ChevronUp,
  ChevronUpThin,
  CreditCard,
  Edit,
  Email,
  EmailSimple,
  ExclamationFilled,
  ExclamationStroke,
  Exit,
  ExitThin,
  Expand,
  Facebook,
  Gift,
  Google,
  GooglePodcasts,
  Hamburger,
  Headphones,
  IHeartRadio,
  InfoFilled,
  InfoStroke,
  Instagram,
  Key,
  Lightbulb,
  Line,
  LineChevronDown,
  LineChevronDownThin,
  LineChevronLeft,
  LineChevronLeftThin,
  LineChevronRight,
  LineChevronRightThin,
  LineChevronUp,
  LineChevronUpThin,
  Link,
  LinkedIn,
  LinkedInFilled,
  Listen,
  Lock,
  MinusStroke,
  NewWindow,
  NotificationAdd,
  Pause,
  Play,
  Plus,
  PlusStroke,
  PlusThin,
  PlusThinStroke,
  QR,
  Refresh,
  Search,
  ShareDrawer,
  Spotify,
  Stitcher,
  Terminal,
  TerminalWhite,
  Translate,
  Triangle,
  TriangleDown,
  TriangleLeft,
  TriangleRight,
  TriangleUp,
  Tune,
  TuneIn,
  Twitter,
  UserAccountProfile,
  VisibilityOff,
  VisibilityOn,
  WeekendLogo,
  X,
  YouTube
};
//# sourceMappingURL=index.js.map